// import { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import { LoadScript } from "@react-google-maps/api";
// import Autocomplete from "react-google-autocomplete";
// import {
//   WASH_COUNT_CATALOG,
//   WASH_INCLUDES_OPTIONS,
//   initialLocationPool,
//   initialSets,
//   SUPER_ADMIN_NAME,
//   PROVIDER_NAME,
// } from "admin/components/pakageSetComp/mockData";
// import "./MonthlyPackages.css";

// const BASE = "https://production.washta.com/api";
// const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("accessToken")}` });
// const mapConfigToSet = (config) => {
//   const snap = (config.serviceNameSnapshot || "").toLowerCase();
//   const washIncludes = WASH_INCLUDES_OPTIONS.find((o) => o.toLowerCase() === snap) || config.serviceNameSnapshot || "";
//   const shopSvcPrices = config.shopServicePrices || {};
//   const refPrices = config.refPrices || {};
//   const carTypes = config.carTypes || ["Sedan", "SUV"];
//   const singleWashPrice = {};
//   carTypes.forEach((ct) => {
//     singleWashPrice[ct] = refPrices[ct] ?? shopSvcPrices[ct] ?? "";
//   });
//   const refPricesFromShop = carTypes.some(
//     (ct) => refPrices[ct] === undefined && shopSvcPrices[ct] !== undefined
//   );

//   return {
//     id: config.setId || "set-seller",
//     name: config.setName || "My Packages",
//     locked: false,
//     washIncludes,
//     vehicleTypes: carTypes,
//     singleWashPrice,
//     shopServicePrices: shopSvcPrices,
//     refPricesFromShop,
//     packages: (config.tiers || []).map((t) => {
//       // Backend stores the total monthly price per tier; the UI works in price-per-wash,
//       // so convert once here on load and convert back once on save (see handleSave).
//       // A tier with no price saved yet defaults to the single wash price (0% savings)
//       // instead of forcing the seller to retype the same number in every package.
//       const monthlyPrices = t.prices || {};
//       const price = {};
//       carTypes.forEach((ct) => {
//         const monthly = Number(monthlyPrices[ct]) || 0;
//         price[ct] = monthly > 0 && t.washCount > 0 ? monthly / t.washCount : singleWashPrice[ct] ?? "";
//       });
//       return {
//         id: t.tierId || t.templateId,
//         washCatalogId: t.templateId,
//         washCount: t.washCount,
//         frequency: `${t.daysPerWeek}x/week`,
//         name: t.defaultDisplayName,
//         nameLocked: true,
//         on: !!t.isActive,
//         popular: !!t.isFeatured,
//         price,
//       };
//     }),
//   };
// };

// const mapApiLocation = (l, setId) => ({
//   id: `loc-${l.locationId}`,
//   _locationId: String(l.locationId),
//   _shopId: String(l.shopId),
//   name: l.locationDisplayName || l.city || "Unnamed",
//   activePackages: 0,
//   setId: l.attachedSetId ? (setId || l.attachedSetId) : null,
// });
// let uid = 1000;
// const nextId = (prefix) => `${prefix}-${uid++}`;

// const GOOGLE_MAPS_API_KEY = "AIzaSyDkYZEMg8ZH5EhRqdkLF-GyeHrhpZBlSd0";
// const GOOGLE_MAPS_LIBRARIES = ["places"];

// function SkeletonBar({ width = "100%", height = 14, style = {} }) {
//   return <div className="mp-skel" style={{ width, height, ...style }} />;
// }

// function MonthlyPackagesSkeleton() {
//   return (
//     <div className="mp-app">
//       {/* Topbar */}
//       <div className="mp-topbar">
//         <div style={{ flex: 1, minWidth: 240 }}>
//           <SkeletonBar width={220} height={22} style={{ marginBottom: 10 }} />
//           <SkeletonBar width="min(420px, 90%)" height={13} />
//         </div>
//         <div className="mp-provider-badge">
//           <SkeletonBar width={30} height={30} style={{ borderRadius: "50%" }} />
//           <div>
//             <SkeletonBar width={90} height={12} style={{ marginBottom: 6 }} />
//             <SkeletonBar width={70} height={10} />
//           </div>
//         </div>
//       </div>

//       {/* Lock notice */}
//       <div className="mp-notice">
//         <SkeletonBar width={18} height={18} style={{ borderRadius: 5, flexShrink: 0 }} />
//         <div style={{ flex: 1 }}>
//           <SkeletonBar width="92%" height={12} style={{ marginBottom: 8 }} />
//           <SkeletonBar width="68%" height={12} />
//         </div>
//       </div>

//       {/* Tabs */}
//       <div className="mp-tabs">
//         {[0, 1].map((i) => (
//           <div key={i} className="mp-tab" style={{ cursor: "default" }}>
//             <div style={{ width: "100%" }}>
//               <SkeletonBar width={110} height={13} style={{ marginBottom: 8 }} />
//               <SkeletonBar width={70} height={10} />
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Set name & vehicles */}
//       <div className="mp-section">
//         <div className="mp-section-grid">
//           {[0, 1, 2].map((i) => (
//             <div key={i}>
//               <SkeletonBar width={100} height={10} style={{ marginBottom: 10 }} />
//               <SkeletonBar width="100%" height={38} style={{ borderRadius: 10 }} />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Single wash price */}
//       <div className="mp-section tint">
//         <SkeletonBar width={230} height={15} style={{ marginBottom: 8 }} />
//         <SkeletonBar width="min(340px, 90%)" height={12} style={{ marginBottom: 18 }} />
//         <div className="mp-price-row">
//           {[0, 1].map((i) => (
//             <div key={i} className="mp-price-field">
//               <SkeletonBar width={46} height={13} />
//               <SkeletonBar width={120} height={36} style={{ borderRadius: 10 }} />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Packages & price */}
//       <div className="mp-section">
//         <div className="mp-packages-header">
//           <SkeletonBar width={170} height={11} />
//           <SkeletonBar width={140} height={34} style={{ borderRadius: 10 }} />
//         </div>
//         <div className="mp-packages-grid">
//           {[0, 1, 2].map((i) => (
//             <div key={i} className="mp-package-card">
//               <div className="mp-package-card-top">
//                 <div style={{ flex: 1 }}>
//                   <SkeletonBar width={110} height={14} style={{ marginBottom: 8 }} />
//                   <SkeletonBar width={80} height={11} />
//                 </div>
//                 <SkeletonBar width={38} height={22} style={{ borderRadius: 999 }} />
//               </div>
//               <SkeletonBar width={90} height={10} style={{ margin: "16px 0 8px" }} />
//               <SkeletonBar width="100%" height={36} style={{ borderRadius: 10, marginBottom: 14 }} />
//               <SkeletonBar width={110} height={10} style={{ marginBottom: 8 }} />
//               <SkeletonBar width="100%" height={36} style={{ borderRadius: 10, marginBottom: 12 }} />
//               <SkeletonBar width="60%" height={10} />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Locations */}
//       <div className="mp-section">
//         <SkeletonBar width={280} height={15} style={{ marginBottom: 16 }} />
//         <SkeletonBar width="min(340px, 100%)" height={38} style={{ borderRadius: 10 }} />
//       </div>
//     </div>
//   );
// }

// /* -------------------- Class: TopBar -------------------- */
// /** @author Super Admin — Ahmed Raza */
// function TopBar() {
//   return (
//     <div className="mp-topbar">
//       <div>
//         <h1 className="h1-all-heading">Monthly Packages</h1>
//         <p className="mp-subtitle">
//           A package set is a price card. Build it once, then attach every location that should
//           use those prices — you don't configure each building separately.
//         </p>
//       </div>
//       {/* <div className="mp-provider-badge">
//         <div className="mp-provider-avatar">{PROVIDER_NAME[0]}</div>
//         <div className="mp-provider-meta">
//           <div className="mp-provider-name">{PROVIDER_NAME}</div>
//           <div className="mp-provider-role">Provider console</div>
//         </div>
//       </div> */}
//     </div>
//   );
// }

// /* -------------------- Class: LockNotice -------------------- */
// /** @author Super Admin — Ahmed Raza */
// function LockNotice() {
//   return (
//     <div className="mp-notice">
//       <span>🔒</span>
//       <div>
//         <b>Wash counts are set by Washta and are the same for every provider.</b> The name shown
//         in the app comes from Washta too — you choose which packages to switch on and what to
//         charge. Each count is tied to a weekly frequency — a customer on the 8-wash package picks
//         exactly 2 preferred days.
//       </div>
//     </div>
//   );
// }
// function SetsListView({ sets, locationPool, onEdit, onNewSet, onDeleteSet }) {
//   const countLocations = (setId) => locationPool.filter((l) => l.setId === setId).length;
//   const countActivePackages = (set) => set.packages.filter((p) => p.on && !p._deleted).length;
//   const initials = (name) => (name || "?").trim().charAt(0).toUpperCase() || "?";

//   return (
//     <div className="mp-section">
//       <style>{`
//         .mp-list-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;}
//         .mp-sets-grid{display:grid;grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));gap:14px;}
//         .mp-set-card{
//           position:relative;display:flex;flex-direction:column;gap:14px;
//           padding:18px 18px 16px;border-radius:16px;background:#fff;
//           border:1px solid #ececf3;
//           box-shadow:0 1px 2px rgba(20,20,43,0.04);
//           transition:box-shadow .18s ease, transform .18s ease, border-color .18s ease;
//         }
//         .mp-set-card:hover{
//           box-shadow:0 10px 24px rgba(107,95,228,0.12);
//           border-color:#d9d4ff;
//           transform:translateY(-2px);
//         }
//         .mp-set-card-top{display:flex;align-items:center;gap:12px;}
//         .mp-set-avatar{
//           width:40px;height:40px;border-radius:12px;flex-shrink:0;
//           display:flex;align-items:center;justify-content:center;
//           background:linear-gradient(135deg,#7c6cf5,#6b5fe4);
//           color:#fff;font-weight:700;font-size:15px;
//         }
//         .mp-set-name{font-weight:600;font-size:14.5px;color:#1c1c28;line-height:1.3;
//           overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
//         .mp-set-service{font-size:11.5px;color:#8b8b9e;margin-top:2px;
//           overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
//         .mp-set-stats{display:flex;gap:8px;flex-wrap:wrap;}
//         .mp-set-stat{
//           display:flex;align-items:center;gap:5px;font-size:11.5px;color:#5b5b6e;
//           background:#f5f4fb;border-radius:999px;padding:5px 10px;font-weight:500;
//         }
//         .mp-set-stat b{color:#1c1c28;font-weight:700;}
//         .mp-set-card-actions{display:flex;align-items:center;gap:8px;margin-top:2px;}
//         .mp-set-edit-btn{
//           flex:1;text-align:center;padding:9px 14px;border-radius:10px;
//           background:#6b5fe4;color:#fff;font-weight:600;font-size:12.5px;
//           border:none;cursor:pointer;transition:background .15s ease, transform .1s ease;
//         }
//         .mp-set-edit-btn:hover{background:#5b4fd9;}
//         .mp-set-edit-btn:active{transform:scale(0.97);}
//         .mp-set-delete-btn{
//           width:36px;height:36px;border-radius:10px;border:1px solid #f0d9d9;
//           background:#fff5f5;color:#d95b5b;display:flex;align-items:center;justify-content:center;
//           cursor:pointer;flex-shrink:0;transition:background .15s ease, border-color .15s ease;
//         }
//         .mp-set-delete-btn:hover{background:#ffe3e3;border-color:#f3b8b8;}
//         .mp-sets-empty{
//           text-align:center;padding:56px 20px;color:#9a9aac;font-size:13px;
//           border:1.5px dashed #e3e1f2;border-radius:16px;background:#faf9ff;
//         }
//         .mp-new-set-btn{
//           display:inline-flex;align-items:center;gap:6px;padding:10px 18px;border-radius:10px;
//           background:#6b5fe4;color:#fff;font-weight:600;font-size:13px;border:none;cursor:pointer;
//           transition:background .15s ease, transform .1s ease;
//         }
//         .mp-new-set-btn:hover{background:#5b4fd9;}
//         .mp-new-set-btn:active{transform:scale(0.97);}
//       `}</style>

//       <div className="mp-list-header">
//         <div>
//           <div className="mp-eyebrow">Your package sets</div>
//           <div className="mp-hint" style={{ marginTop: 2 }}>
//             {sets.length} set{sets.length === 1 ? "" : "s"} · click Edit to change prices or packages
//           </div>
//         </div>
//         <button className="mp-new-set-btn" onClick={onNewSet}>
//           <span style={{ fontSize: 15, lineHeight: 1 }}>+</span> New set
//         </button>
//       </div>

//       {sets.length === 0 ? (
//         <div className="mp-sets-empty">
//           No package sets yet — click <b style={{ color: "#6d5bf0" }}>+ New set</b> to create your first one.
//         </div>
//       ) : (
//         <div className="mp-sets-grid">
//           {sets.map((s) => (
//             <div key={s.id} className="mp-set-card">
//               <div className="mp-set-card-top">
//                 <div className="mp-set-avatar">{initials(s.name)}</div>
//                 <div style={{ minWidth: 0, flex: 1 }}>
//                   <div className="mp-set-name">{s.name || "Untitled set"}</div>
//                   <div className="mp-set-service">{s.washIncludes || "No service selected"}</div>
//                 </div>
//               </div>

//               <div className="mp-set-stats">
//                 <span className="mp-set-stat">
//                   <b>{countActivePackages(s)}</b> active packages
//                 </span>
//                 <span className="mp-set-stat">
//                   <b>{countLocations(s.id)}</b> locations
//                 </span>
//               </div>

//               <div className="mp-set-card-actions">
//                 <button className="mp-set-edit-btn" onClick={() => onEdit(s.id)}>
//                   ✎ Edit
//                 </button>
//                 <button
//                   className="mp-set-delete-btn"
//                   title="Delete this package set"
//                   onClick={() => onDeleteSet(s.id)}
//                 >
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <polyline points="3 6 5 6 21 6" />
//                     <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
//                     <path d="M10 11v6" />
//                     <path d="M14 11v6" />
//                     <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
//                   </svg>
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* -------------------- Class: SetNameAndVehicles -------------------- */
// /** @author Super Admin — Ahmed Raza */
// function SetNameAndVehicles({ set, onUpdate }) {
//   const [showCustomInput, setShowCustomInput] = useState(false);
//   const [customName, setCustomName] = useState("");

//   const toggleVehicle = (type) => {
//     if (set.locked) return;
//     const active = set.vehicleTypes.includes(type);
//     let vehicleTypes;
//     let singleWashPrice = { ...set.singleWashPrice };
//     let packages = set.packages;
//     if (active) {
//       vehicleTypes = set.vehicleTypes.filter((v) => v !== type);
//     } else {
//       vehicleTypes = [...set.vehicleTypes, type];
//       if (singleWashPrice[type] === undefined) singleWashPrice[type] = "";
//       packages = packages.map((p) => ({
//         ...p,
//         price: { ...p.price, [type]: p.price[type] ?? "" },
//       }));
//     }
//     onUpdate({ ...set, vehicleTypes, singleWashPrice, packages });
//   };

//   const removeCustomVehicle = (type) => {
//     const vehicleTypes = set.vehicleTypes.filter((v) => v !== type);
//     const singleWashPrice = { ...set.singleWashPrice };
//     delete singleWashPrice[type];
//     const packages = set.packages.map((p) => {
//       const price = { ...p.price };
//       delete price[type];
//       return { ...p, price };
//     });
//     onUpdate({ ...set, vehicleTypes, singleWashPrice, packages });
//   };

//   const addCustomVehicle = () => {
//     const name = customName.trim();
//     if (!name || set.vehicleTypes.includes(name)) return;
//     onUpdate({
//       ...set,
//       vehicleTypes: [...set.vehicleTypes, name],
//       singleWashPrice: { ...set.singleWashPrice, [name]: "" },
//       packages: set.packages.map((p) => ({ ...p, price: { ...p.price, [name]: "" } })),
//     });
//     setCustomName("");
//     setShowCustomInput(false);
//   };

//   const isDefault = (type) => type === "Sedan" || type === "SUV";

//   return (
//     <div className="mp-section">
//       <div className="mp-section-grid">
//         <div>
//           <div className="mp-field-label">Set name</div>
//           <input
//             className="mp-input"
//             value={set.name}
//             placeholder="e.g. Standard Packages"
//             onChange={(e) => onUpdate({ ...set, name: e.target.value })}
//           />
//           <div className="mp-hint">Your own label — customers never see this</div>
//         </div>

//         <div>
//           <div className="mp-field-label">What one wash in this package includes</div>
//           <select
//             className="mp-select"
//             value={set.washIncludes}
//             disabled={set.locked}
//             onChange={(e) => onUpdate({ ...set, washIncludes: e.target.value })}
//           >
//             <option value="">Select...</option>
//             {WASH_INCLUDES_OPTIONS.map((o) => (
//               <option key={o} value={o}>
//                 {o}
//               </option>
//             ))}
//           </select>
//           <div className="mp-hint">
//             Every package in this set delivers this service.{" "}
//             {set.locked ? "Locked once the first package is sold." : "Editable until first sale."}
//           </div>
//         </div>

//         <div>
//           <div className="mp-field-label">Car types</div>
//           <div className="mp-cartype-row">
//             {["Sedan", "SUV"].map((type) => {
//               const checked = set.vehicleTypes.includes(type);
//               return (
//                 <div
//                   key={type}
//                   className={`mp-cartype-chip ${checked ? "checked" : ""}`}
//                   onClick={() => toggleVehicle(type)}
//                 >
//                   <span className="box">{checked ? "✓" : ""}</span>
//                   {type}
//                 </div>
//               );
//             })}
//             {set.vehicleTypes
//               .filter((t) => !isDefault(t))
//               .map((type) => (
//                 <div key={type} className="mp-cartype-chip checked">
//                   <span className="box">✓</span>
//                   {type}
//                   <span
//                     className="remove"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       removeCustomVehicle(type);
//                     }}
//                   >
//                     ×
//                   </span>
//                 </div>
//               ))}
//             {!showCustomInput && (
//               <button className="mp-add-custom-btn" onClick={() => setShowCustomInput(true)}>
//                 + Add custom
//               </button>
//             )}
//           </div>
//           {showCustomInput && (
//             <div className="mp-custom-input-row">
//               <input
//                 className="mp-input"
//                 placeholder="e.g. Pickup Truck"
//                 value={customName}
//                 autoFocus
//                 onChange={(e) => setCustomName(e.target.value)}
//                 onKeyDown={(e) => e.key === "Enter" && addCustomVehicle()}
//               />
//               <button className="mp-btn violet" onClick={addCustomVehicle}>
//                 Add
//               </button>
//               <button className="mp-btn" onClick={() => setShowCustomInput(false)}>
//                 Cancel
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* -------------------- Class: SingleWashPrice -------------------- */
// /** @author Super Admin — Ahmed Raza */
// function SingleWashPrice({ set, onUpdate }) {
//   const updatePrice = (type, value) => {
//     const newSingle = Number(value) || 0;
//     const oldSingle = Number(set.singleWashPrice[type]) || 0;
//     const updatedPackages = set.packages.map((p) => {
//       const currentPrice = Number(p.price[type]) || 0;
//       const wasAutoFilled = oldSingle > 0 ? currentPrice === oldSingle : currentPrice === 0;
//       if (!wasAutoFilled) return p; 
//       return {
//         ...p,
//         price: { ...p.price, [type]: newSingle > 0 ? newSingle : "" },
//       };
//     });
//     onUpdate({ ...set, singleWashPrice: { ...set.singleWashPrice, [type]: value }, packages: updatedPackages });
//   };
//   return (
//     <div className="mp-section tint">
//       <h3 className="mp-section-title">Single wash price at these locations</h3>
//       <p className="mp-section-desc">
//         What one wash costs if a customer buys it on its own, not in a package. Savings below are
//         calculated from this.
//       </p>
//       <div className="mp-price-row">
//         {set.vehicleTypes.map((type) => (
//           <div className="mp-price-field" key={type}>
//             <span className="veh-label">{type}</span>
//             <div className="mp-aed-input">
//               <span className="prefix">AED</span>
//               <input
//               min="1"
//                 onWheel={(e) => e.target.blur()}
//                 type="number"
//                 value={set.singleWashPrice[type] ?? ""}
//                 onChange={(e) => updatePrice(type, e.target.value)}
//               />
//             </div>
//           </div>
//         ))}
//         {set.vehicleTypes.length === 0 && (
//           <span className="mp-hint">Add a car type above first.</span>
//         )}
//       </div>
//     </div>
//   );
// }

// /* -------------------- Class: PackageCard -------------------- */
// /** @author Super Admin — Ahmed Raza */
// function PackageCard({ pkg, set, onUpdate, onDelete, onSetPopular }) {
//   const [editingName, setEditingName] = useState(false);

//   // The card's input edits the monthly total (what the customer pays for the
//   // whole package) — everything else (pkg.price, savings %, save-to-backend)
//   // still works in price-per-wash, so convert on the way in and out.
//   const updateMonthlyPrice = (type, value) => {
//     if (value === "") {
//       onUpdate({ ...pkg, price: { ...pkg.price, [type]: "" } });
//       return;
//     }
//     const monthly = Number(value);
//     const perWash = pkg.washCount > 0 ? monthly / pkg.washCount : monthly;
//     onUpdate({ ...pkg, price: { ...pkg.price, [type]: perWash } });
//   };

//   return (
//     <div className={`mp-package-card ${pkg.popular ? "selected" : ""}`}>
//       <div className="mp-package-card-top">
//         <div>
//           <div className="mp-package-title">{pkg.name}</div>
//           <div className="mp-package-freq">
//             <span className="lock">🔒</span>
//             {pkg.frequency} · set by Washta
//           </div>
//         </div>
//         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <button
//             className={`mp-toggle ${pkg.on ? "on" : ""}`}
//             onClick={() => onUpdate({ ...pkg, on: !pkg.on })}
//           >
//             <span className="dot" />
//           </button>
//           <button
//             className="mp-icon-btn danger"
//             title="Delete package"
//             style={{ marginLeft: 2 }}
//             onClick={() => onDelete(pkg.id)}
//           >
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//               <polyline points="3 6 5 6 21 6"/>
//               <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
//               <path d="M10 11v6"/><path d="M14 11v6"/>
//               <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
//             </svg>
//           </button>
//         </div>
//       </div>

//       {pkg.popular && <div className="mp-popular-tag" style={{ marginTop: 10 }}>⭐ Popular</div>}

//       <div className="mp-package-field-label">
//         Name shown in app{" "}
//         {!editingName && <span className="mp-tiny-tag">SET BY WASHTA</span>}
//       </div>
//       <div className="mp-name-row">
//         <input
//           className="mp-input"
//           value={pkg.name}
//           disabled={!editingName}
//           onChange={(e) => onUpdate({ ...pkg, name: e.target.value })}
//         />
//         <button className="mp-icon-btn" title="Edit name" onClick={() => setEditingName((v) => !v)}>
//           ✎
//         </button>
//       </div>

//       <div className="mp-package-field-label">Total price per month (AED)</div>
//       {set.vehicleTypes.map((type) => {
//         const perWash = pkg.price[type];
//         const monthlyValue =
//           perWash === "" || perWash === undefined || perWash === null || Number.isNaN(Number(perWash))
//             ? ""
//             : Math.round(Number(perWash) * (pkg.washCount || 0) * 100) / 100;
//         return (
//           <div key={type}>
//             <div className="mp-package-price-row">
//               <span className="veh">{type}</span>
//               <div className="mp-aed-input">
//                 <span className="prefix">AED</span>
//                 <input
//                   type="number"
//                   value={monthlyValue}
//                   onChange={(e) => updateMonthlyPrice(type, e.target.value)}
//                 />
//               </div>
//             </div>
//           </div>
//         );
//       })}

//       <div className="mp-package-summary">
//         {set.vehicleTypes
//           .map((type) => {
//             const perWash = Number(pkg.price[type]) || 0;
//             const monthlyTotal = perWash * (pkg.washCount || 0);
//             return perWash > 0 ? `${type} AED ${perWash.toFixed(2)}/wash (AED ${monthlyTotal.toFixed(2)}/mo)` : null;
//           })
//           .filter(Boolean)
//           .join(" · ")}
//       </div>
//       <div className="mp-package-savings">
//         {set.vehicleTypes
//           .map((type) => {
//             const perWash = Number(pkg.price[type]) || 0;
//             const refPrice = Number(set.shopServicePrices?.[type]) || Number(set.singleWashPrice[type]) || 0;
//             if (!(refPrice > 0 && perWash > 0 && pkg.washCount > 0)) return null;
//             const fullPrice = refPrice * pkg.washCount;
//             const packageTotal = perWash * pkg.washCount;
//             const pct = ((fullPrice - packageTotal) / fullPrice) * 100;
//             return `${pct >= 0 ? "Saves" : "Costs"} ${Math.abs(pct).toFixed(1)}% ${type}`;
//           })
//           .filter(Boolean)
//           .join(" · ")}
//       </div>

//       <div className="mp-package-footer">
//         <label className="mp-radio-row">
//           <input
//             type="radio"
//             name={`popular-${set.id}`}
//             checked={pkg.popular}
//             onChange={() => onSetPopular(pkg.id)}
//           />
//           Show "Popular" badge
//         </label>
//       </div>
//     </div>
//   );
// }

// /* -------------------- Class: PackagesSection -------------------- */
// /** @author Super Admin — Ahmed Raza */
// function PackagesSection({ set, onUpdateSet, washTemplates }) {
//   const availableToAdd = washTemplates.filter(
//     (c) => !set.packages.some((p) => p.washCatalogId === c.id && !p._deleted)
//   );

//   const addPackage = (catalogId) => {
//     if (!catalogId) return;
//     const catalog = washTemplates.find((c) => c.id === catalogId);
//     if (!catalog) return;
//     const price = {};
//     set.vehicleTypes.forEach((t) => {
//       const single = Number(set.singleWashPrice[t]) || 0;
//       price[t] = single > 0 ? single : "";
//     });
//     const newPkg = {
//       id: nextId("pkg"),
//       washCatalogId: catalog.id,
//       washCount: catalog.washCount,
//       frequency: catalog.frequency,
//       name: catalog.defaultName,
//       nameLocked: true,
//       on: true,
//       popular: set.packages.length === 0,
//       price,
//     };
//     onUpdateSet({ ...set, packages: [...set.packages, newPkg] });
//   };

//   const updatePackage = (updated) => {
//     onUpdateSet({ ...set, packages: set.packages.map((p) => (p.id === updated.id ? updated : p)) });
//   };

//   const deletePackage = (id) => {
//     onUpdateSet({ ...set, packages: set.packages.map((p) => p.id === id ? { ...p, on: false, _deleted: true } : p) });
//   };

//   const setPopular = (id) => {
//     onUpdateSet({
//       ...set,
//       packages: set.packages.map((p) => ({ ...p, popular: p.id === id })),
//     });
//   };

//   return (
//     <div className="mp-section">
//       <div className="mp-packages-header">
//         <div className="mp-eyebrow">Packages &amp; monthly price</div>
//         <select
//           className="mp-add-package-select"
//           value=""
//           onChange={(e) => addPackage(e.target.value)}
//         >
//           <option value="">+ Add package</option>
//           {availableToAdd.map((c) => (
//             <option key={c.id} value={c.id}>
//               {c.defaultName}
//             </option>
//           ))}
//         </select>
//       </div>

//       {set.packages.length === 0 || set.packages.every((p) => p._deleted) ? (
//         <div className="mp-empty-packages">
//           No packages yet — pick a wash count from "+ Add package" above.
//         </div>
//       ) : (
//         <div className="mp-packages-grid">
//           {set.packages.filter((pkg) => !pkg._deleted).map((pkg) => (
//             <PackageCard
//               key={pkg.id}
//               pkg={pkg}
//               set={set}
//               onUpdate={updatePackage}
//               onDelete={deletePackage}
//               onSetPopular={setPopular}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// function LocationsSection({ set, locationPool, onToggleLocation, onCreateLocation }) {
//   const [showCreate, setShowCreate] = useState(false);
//   const [placeQuery, setPlaceQuery] = useState("");
//   const [pickedPlace, setPickedPlace] = useState(null);
//   const [displayName, setDisplayName] = useState("");
//   const [selectedLocId, setSelectedLocId] = useState("");
//   const [menuOpen, setMenuOpen] = useState(false);
//   const menuRef = useRef(null);
//   const autocompleteRef = useRef(null);

//   const activeTierCount = set.packages.filter((p) => p.on).length;
//   const attachedLocations = locationPool.filter((l) => l.setId === set.id);
//   const availableLocations = locationPool.filter((l) => !l.setId);

//   // auto-select first attached location
//   useEffect(() => {
//     if (attachedLocations.length && !attachedLocations.find((l) => l.id === selectedLocId)) {
//       setSelectedLocId(attachedLocations[0].id);
//     }
//   }, [attachedLocations]);

//   // close menu on outside click
//   useEffect(() => {
//     const handler = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   const selectedLoc = attachedLocations.find((l) => l.id === selectedLocId) || attachedLocations[0] || null;

//   const handleAddFromDropdown = (e) => {
//     const locId = e.target.value;
//     if (!locId) return;
//     onToggleLocation(locId, set.id);
//     e.target.value = "";
//   };

//   const handlePlaceSelected = (place) => {
//     const lat = typeof place?.geometry?.location?.lat === "function" ? place.geometry.location.lat() : place?.geometry?.location?.lat ?? null;
//     const lng = typeof place?.geometry?.location?.lng === "function" ? place.geometry.location.lng() : place?.geometry?.location?.lng ?? null;
//     setPickedPlace({ lat, lng, formattedAddress: place?.formatted_address || "", placeId: place?.place_id || null });
//     setPlaceQuery(place?.formatted_address || place?.name || "");
//   };

//   const resetCreateForm = () => { setPlaceQuery(""); setPickedPlace(null); setDisplayName(""); };

//   const handleAddLocation = () => {
//     const name = displayName.trim();
//     if (!name) return;
//     onCreateLocation(name, pickedPlace || {});
//     resetCreateForm();
//     setShowCreate(false);
//   };

//   const canAdd = displayName.trim().length > 0;

//   return (
//     <div className="mp-section">
//       <div className="mp-loc-header">
//         <div className="mp-loc-title-row">
//           📍 Locations using this set{" "}
//           <span className="mp-loc-desc">— pick from the dropdown to add, or create a package-only location</span>
//         </div>
//       </div>

//       <div className="mp-loc-add-dropdown-row">
//         <select className="mp-select" value="" onChange={(e) => {
//           const val = e.target.value;
//           if (val === "__create__") {
//             setShowCreate((v) => !v);
//             if (showCreate) resetCreateForm();
//           } else if (val) {
//             onToggleLocation(val, set.id);
//           }
//           e.target.value = "";
//         }}>
//           <option value="">+ Add location...</option>
//           <option value="__create__">Create a package-only location</option>
//           {availableLocations.length > 0 && (
//             <optgroup label="Existing locations">
//               {availableLocations.map((loc) => (
//                 <option key={loc.id} value={loc.id}>{loc.name}</option>
//               ))}
//             </optgroup>
//           )}
//         </select>
//         {availableLocations.length === 0 && (
//           <span className="mp-hint">No unassigned locations left — create a new one.</span>
//         )}
//       </div>

//       {showCreate && (
//         <div className="mp-loc-create-card">
//           <div>
//             <div className="mp-field-label">Search building / address (for map pin)</div>
//             <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
//               <Autocomplete
//                 ref={autocompleteRef}
//                 onPlaceSelected={handlePlaceSelected}
//                 options={{ types: ["establishment", "geocode"], componentRestrictions: { country: "AE" } }}
//                 fields={["name", "formatted_address", "geometry", "place_id"]}
//                 value={placeQuery}
//                 onChange={(e) => setPlaceQuery(e.target.value)}
//                 placeholder="Search for a building / address in UAE"
//                 className="mp-input"
//                 style={{ width: "100%" }}
//               />
//             </LoadScript>
//             {pickedPlace && (
//               <div className="mp-loc-pinned-badge">
//                 <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#6b5fe4" strokeWidth="2.5" strokeLinecap="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
//                 Pinned{pickedPlace.formattedAddress ? ` — ${pickedPlace.formattedAddress}` : ""}
//               </div>
//             )}
//           </div>
//           <div>
//             <div className="mp-field-label">Display location name</div>
//             <input
//               className="mp-input"
//               placeholder="e.g. Marina Heights Tower B"
//               value={displayName}
//               onChange={(e) => setDisplayName(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && canAdd && handleAddLocation()}
//             />
//             <div className="mp-hint">Customers see this name — not the searched address.</div>
//           </div>
//           <div className="mp-loc-create-actions">
//             <button className="mp-btn violet" disabled={!canAdd} onClick={handleAddLocation}>Add location</button>
//             <button className="mp-btn" onClick={() => { setShowCreate(false); resetCreateForm(); }}>Cancel</button>
//           </div>
//         </div>
//       )}

//       {attachedLocations.length === 0 ? (
//         <div className="mp-empty-packages">No locations attached yet — add one from the dropdown above.</div>
//       ) : (
//         <div className="mp-loc-dropdown-wrap" ref={menuRef}>
//           {/* Trigger */}
//           <button
//             type="button"
//             className={`mp-loc-trigger ${menuOpen ? "open" : ""}`}
//             onClick={() => setMenuOpen((v) => !v)}
//           >
//             <span className="mp-loc-pin">
//               <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6B5FE4" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
//             </span>
//             <span className="mp-loc-trigger-value">
//               {selectedLoc ? selectedLoc.name : `${attachedLocations.length} locations`}
//             </span>
//             <span className="mp-loc-count-badge">{attachedLocations.length}</span>
//             <span className={`mp-loc-arrow ${menuOpen ? "open" : ""}`}>
//               <svg width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" stroke="#6B5FE4" strokeWidth="1.5" fill="none" strokeLinecap="round"/></svg>
//             </span>
//           </button>

//           {/* Delete button — same style as shop delete */}
//           {selectedLoc && (
//             <button
//               type="button"
//               className="mp-loc-delete-btn"
//               title={`Remove ${selectedLoc.name}`}
//               onClick={() => { onToggleLocation(selectedLoc.id, set.id); setSelectedLocId(""); setMenuOpen(false); }}
//             >
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <polyline points="3 6 5 6 21 6"/>
//                 <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
//                 <path d="M10 11v6"/><path d="M14 11v6"/>
//                 <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
//               </svg>
//             </button>
//           )}

//           {/* Dropdown menu */}
//           {menuOpen && (
//             <div className="mp-loc-menu">
//               {attachedLocations.map((loc, i) => (
//                 <button
//                   key={loc.id}
//                   type="button"
//                   className={`mp-loc-item ${selectedLocId === loc.id ? "active" : ""}`}
//                   style={{ animationDelay: `${i * 0.03}s` }}
//                   onClick={() => { setSelectedLocId(loc.id); setMenuOpen(false); }}
//                 >
//                   <span className="mp-loc-item-dot" />
//                   <span className="mp-loc-item-label">{loc.name}</span>
//                   <span className="mp-loc-item-sub">{activeTierCount} active packages</span>
//                   {selectedLocId === loc.id && (
//                     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6B5FE4" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
//                   )}
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       <div className="mp-single-wash-note">
//         ✓ Single-wash service stays available at these locations. Customers choose a one-off wash or a monthly package at checkout.
//       </div>
//     </div>
//   );
// }
// function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }) {
//   // The page sidebar (`.div-sidebar`) is shared/global CSS used across many routes,
//   // so its rendered edge can't be assumed from a fixed pixel value here — measure it
//   // live so the overlay starts exactly where the sidebar ends (0 when it's off-canvas).
//   const [contentLeft, setContentLeft] = useState(0);

//   useEffect(() => {
//     if (!isOpen) return;
//     const sidebarEl = document.querySelector(".div-sidebar");
//     setContentLeft(sidebarEl ? Math.max(0, sidebarEl.getBoundingClientRect().right) : 0);
//   }, [isOpen]);

//   if (!isOpen) return null;
//   return (
//     <div className="mp-confirm-overlay" style={{ left: contentLeft }} onClick={onCancel}>
//       <div className="mp-confirm-box" onClick={(e) => e.stopPropagation()}>
//         <div className="mp-confirm-title">{title}</div>
//         <div className="mp-confirm-message">{message}</div>
//         <div className="mp-confirm-actions">
//           <button className="mp-confirm-btn cancel" onClick={onCancel}>Cancel</button>
//           <button className="mp-confirm-btn delete" onClick={onConfirm}>Yes, Delete</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function FooterBar({ onDiscard, onSave, saveLabel = "Save all changes", saveDisabled = false, discardDisabled = false, saving = false }) {
//   return (
//     <div className="mp-footer-bar">
//       <div className="mp-footer-note">
//         Price changes apply to new purchases — packages already running keep the price they were
//         bought at
//       </div>
//       <div className="mp-footer-actions">
//         <button className="mp-btn" onClick={onDiscard} disabled={discardDisabled || saving} title={discardDisabled ? "No changes to discard" : ""}>
//           Discard
//         </button>
//         <button
//           className="mp-btn violet"
//           onClick={onSave}
//           disabled={saveDisabled || saving}
//           title={saveDisabled ? "Change something first" : ""}
//         >
//           {saving && <span className="mp-btn-spinner" />}
//           {saving ? "Saving…" : saveLabel}
//         </button>
//       </div>
//     </div>
//   );
// }

// /* -------------------- Class: MonthlyPackagesPage (root) -------------------- */
// /** @author Super Admin — Ahmed Raza
//  *  @param {Array} myLocations - raw location records from
//  *  `${BASE}/residential/seller/my-locations` (fetched by the parent Packages
//  *  page and passed down as a prop). When present, these seed/refresh the
//  *  location pool that both the dropdown and the location cards read from.
//  */
// export default function MonthlyPackagesPage({ myLocations = [] }) {
//   const [sets, setSets] = useState([]);
//   const [locationPool, setLocationPool] = useState([]);
//   const [activeId, setActiveId] = useState(null);
//   const [savedSets, setSavedSets] = useState([]);
//   const [savedPool, setSavedPool] = useState([]);
//   const [toast, setToast] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [washTemplates, setWashTemplates] = useState([]);
//   const [apiSetId, setApiSetId] = useState(null);
//   const [shopServicePrices, setShopServicePrices] = useState({});
//   const [viewMode, setViewMode] = useState("list");
//   const [savingSet, setSavingSet] = useState(false);
//   const [confirmDeleteId, setConfirmDeleteId] = useState(null);

//   // Fetch real data on mount
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [configRes, locsRes] = await Promise.all([
//           axios.get(`${BASE}/package-sets/seller/my-config`, { headers: authHeaders() }),
//           axios.get(`${BASE}/package-sets/seller/my-locations`, { headers: authHeaders() }),
//         ]);
//         const config = configRes.data.data || {};

//         // Templates from config.tiers — if empty, fetch directly from tier-templates
//         let templates = (config.tiers || []).map((t) => ({
//           id: t.templateId,
//           washCount: t.washCount,
//           frequency: `${t.daysPerWeek}x/week`,
//           defaultName: t.defaultDisplayName,
//         }));

//         if (!templates.length) {
//           // Fallback: fetch templates directly (works even before seller has a set)
//           try {
//             const tplRes = await axios.get(`${BASE}/package-sets/seller/tier-templates`, { headers: authHeaders() });
//             templates = (tplRes.data.data || []).filter((t) => t.isActive !== false).map((t) => ({
//               id: String(t._id),
//               washCount: t.washCount,
//               frequency: `${t.daysPerWeek}x/week`,
//               defaultName: t.defaultDisplayName,
//             }));
//           } catch (_) {}
//         }
//         if (templates.length) {
//           setWashTemplates(templates);
//         }
//         setApiSetId(config.setId || null);
//         setShopServicePrices(config.shopServicePrices || {});

//         // Only build set if seller already has one saved
//         if (config.setId) {
//           const apiSet = mapConfigToSet(config);
//           setSets([apiSet]);
//           setSavedSets([apiSet]);
//           setActiveId(apiSet.id);
//         }

//         // Locations — all seller shop locations
//         // const currentSetId = config.setId || null;
//         const rawLocs = locsRes.data.data || locsRes.data || [];
//         const apiLocs = (Array.isArray(rawLocs) ? rawLocs : []).map((l) => ({
//           id: `loc-${l.locationId}`,
//           _locationId: String(l.locationId),
//            _shopId: String(l.shopId),
//           _shopId: String(l.shopId),
//           name: l.locationDisplayName || l.city || "Unnamed",
//           activePackages: l.activePackages || 0,
//           // setId: (l.attachedSetId && currentSetId) ? currentSetId : null,
//           setId: l.attachedSetId || null,
//         }));
//         setLocationPool(apiLocs);
//         setSavedPool(apiLocs);
//       } catch (err) {
//         console.error("MonthlyPackagesPage fetch error:", err?.response?.data || err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   const showToast = (msg) => {
//     setToast(msg);
//     setTimeout(() => setToast(null), 2600);
//   };

//   const activeSet = sets.find((s) => s.id === activeId);

//   const updateActiveSet = (updated) => {
//     setSets((prev) => prev.map((s) => (s.id === updated.id ? updated : s)));
//   };
//   const handleNewSet = () => {
//     const id = nextId("set-new");
//     const vehicleTypes = ["Sedan", "SUV"];

//     const singleWashPrice = {};
//     vehicleTypes.forEach((t) => {
//       singleWashPrice[t] = shopServicePrices[t] ?? "";
//     });

//     const draft = {
//       id,
//       name: "",
//       locked: false,
//       washIncludes: "",
//       vehicleTypes,
//       singleWashPrice,
//       shopServicePrices,
//       refPricesFromShop: Object.keys(shopServicePrices).length > 0,
//       packages: washTemplates.map((t) => {
//         const price = {};
//         vehicleTypes.forEach((vt) => {
//           const single = Number(singleWashPrice[vt]) || 0;
//           price[vt] = single > 0 ? single : "";
//         });
//         return {
//           id: t.id,
//           washCatalogId: t.id,
//           washCount: t.washCount,
//           frequency: t.frequency,
//           name: t.defaultName,
//           nameLocked: true,
//           on: false,
//           popular: false,
//           price,
//         };
//       }),
//     };
//     setSets((prev) => [...prev, draft]);
//     setActiveId(id);
//     setViewMode("edit");
//   };

//   const handleEditSet = (id) => {
//     setActiveId(id);
//     setViewMode("edit");
//   };

//   const handleBackToList = () => {
//     // "New Set" pushes an unsaved draft into `sets` immediately (see handleNewSet).
//     // If the user never actually saved it, going back must drop that draft —
//     // otherwise a ghost "Untitled set" card lingers in the list until a page refresh.
//     if (activeId && String(activeId).startsWith("set-new")) {
//       setSets((prev) => prev.filter((s) => s.id !== activeId));
//     }
//     setViewMode("list");
//   };

//   const handleDeleteSet = (id) => {
//     setConfirmDeleteId(id);
//   };

//   const cancelDeleteSet = () => setConfirmDeleteId(null);

//   const confirmDeleteSet = async () => {
//     const id = confirmDeleteId;
//     setConfirmDeleteId(null);
//     const setToDelete = sets.find((s) => s.id === id);

//     // If this is a saved API set, delete from backend too
//     if (apiSetId && setToDelete?.id === apiSetId) {
//       try {
//         await axios.delete(`${BASE}/package-sets/seller/${apiSetId}`, { headers: authHeaders() });
//         setApiSetId(null);
//       } catch (err) {
//         showToast(`Delete failed: ${err?.response?.data?.message || err.message}`);
//         return;
//       }
//     }

//     const remaining = sets.filter((s) => s.id !== id);
//     setSets(remaining);
//     setSavedSets(remaining);

//     // Backend ne locations detach kar diye — fresh fetch karo taake purani locations na dikhen
//     try {
//       const locsRes = await axios.get(`${BASE}/package-sets/seller/my-locations`, { headers: authHeaders() });
//       const rawLocs = locsRes.data.data || locsRes.data || [];
//       const freshLocs = (Array.isArray(rawLocs) ? rawLocs : []).map((l) => ({
//         id: `loc-${l.locationId}`,
//         _locationId: String(l.locationId),
//         _shopId: String(l.shopId),
//         name: l.locationDisplayName || l.city || "Unnamed",
//         activePackages: l.activePackages || 0,
//         setId: null, 
//       }));
//       setLocationPool(freshLocs);
//       setSavedPool(freshLocs);
//     } catch (_) {
      
//       setLocationPool((prev) => prev.map((l) => (l.setId === id ? { ...l, setId: null } : l)));
//       setSavedPool((prev) => prev.map((l) => (l.setId === id ? { ...l, setId: null } : l)));
//     }

//     if (activeId === id) {
//       setActiveId(remaining[0]?.id || null);
//       setViewMode("list");
//     }
//     showToast(`"${setToDelete?.name || "Set"}" deleted`);
//   };

//   const toggleLocation = (locId, setId) => {
//     setLocationPool((prev) =>
//       prev.map((l) => {
//         if (l.id !== locId) return l;
//         return { ...l, setId: l.setId === setId ? null : setId };
//       })
//     );
//   };

//   const createLocation = async (name, coords = {}) => {
//     try {
//       const res = await axios.post(
//         `${BASE}/package-sets/seller/create-location`,
//         { displayName: name, lat: coords.lat, lng: coords.lng, text: coords.formattedAddress || name },
//         { headers: authHeaders() }
//       );
//       const created = res.data.data || res.data;
//       const id = nextId("loc-new");
//       setLocationPool((prev) => [
//         ...prev,
//         {
//           id,
//           _locationId: String(created.locationId),
//           _shopId: String(created.shopId),
//           name,
//           activePackages: 0,
//           setId: activeSet.id,
//         },
//       ]);
//       showToast(`Location "${name}" created`);
//     } catch (err) {
//       showToast(`Failed to create location: ${err?.response?.data?.message || err.message}`);
//     }
//   };

//   const handleDiscard = () => {
//     setSets(savedSets);
//     setLocationPool(savedPool);
//     if (!savedSets.some((s) => s.id === activeId)) {
//       setActiveId(savedSets[0]?.id || null);
//     }
//     setViewMode("list");
//     showToast("Changes discarded");
//   };

//   const handleSave = async () => {
//     setSavingSet(true);
//     try {
//       const activePkgs = activeSet.packages.filter((p) => p.on);
//       if (activePkgs.length > 0 && !activePkgs.some((p) => p.popular)) {
//         const firstActiveId = activePkgs[0].id;
//         updateActiveSet({
//           ...activeSet,
//           packages: activeSet.packages.map((p) => ({ ...p, popular: p.id === firstActiveId })),
//         });
//         showToast("One package must be marked Popular — auto-assigned. Save again to confirm.");
//         return;
//       }

//       const tiers = washTemplates.map((t) => {
//         const pkg = activeSet.packages.find(
//           (p) => String(p.washCatalogId) === String(t.id)
//         );
//         // UI works in price-per-wash; backend expects the total monthly price per tier.
//         const perWashPrices = pkg?.price || {};
//         const monthlyPrices = {};
//         Object.keys(perWashPrices).forEach((ct) => {
//           const perWash = Number(perWashPrices[ct]);
//           monthlyPrices[ct] = perWash > 0 && t.washCount > 0 ? perWash * t.washCount : "";
//         });
//         return {
//           templateId: t.id,
//           isActive: !!pkg?.on && !pkg?._deleted,
//           isFeatured: !!pkg?.on && !pkg?._deleted && !!pkg?.popular,
//           prices: monthlyPrices,
//         };
//       });

//       const saveRes = await axios.post(
//         `${BASE}/package-sets/seller/save-config`,
//         {
//           setId: isNewSet ? undefined : (activeSet._apiSetId || apiSetId || undefined),
//           setName: activeSet.name || "My Packages",
//           serviceNameSnapshot: activeSet.washIncludes || "",
//           carTypes: activeSet.vehicleTypes,
//           refPrices: activeSet.singleWashPrice,
//           tiers,
//         },
//         { headers: authHeaders() }
//       );
//       const savedSetId = saveRes.data.data?.setId || apiSetId;
//       setApiSetId(savedSetId);

//       // A brand-new set only has a local draft id (e.g. "set-new-1005") until the
//       // first successful save. Reconcile it — and every location pointing at it —
//       // to the real backend id now, otherwise the *next* save can't tell which
//       // locations were already attached (it compares against the stale draft id),
//       // so detaching a location silently never reaches the production.
//       const oldSetId = activeSet.id;
//       const reconciledSets = sets.map((s) => (s.id === oldSetId ? { ...s, id: savedSetId } : s));
//       const reconciledPool = locationPool.map((l) =>
//         l.setId === oldSetId ? { ...l, setId: savedSetId } : l
//       );

//       const prevById = Object.fromEntries(savedPool.map((l) => [l.id, l]));
//       for (const loc of reconciledPool) {
//         if (!loc._locationId) continue;
//         const prev = prevById[loc.id];
//         const rawPrev = prev?.setId || null;
//         const prevSetId = rawPrev && /^[a-f\d]{24}$/i.test(rawPrev) ? rawPrev : null;
//         const currSetId = loc.setId ? savedSetId : null;
//         if (prevSetId === currSetId) continue;
//         if (prevSetId) {
//           await axios.delete(
//             `${BASE}/package-sets/seller/${prevSetId}/detach-location/${loc._locationId}`,
//             { headers: authHeaders() }
//           );
//         }
//         if (currSetId) {
//           await axios.post(
//             `${BASE}/package-sets/seller/${currSetId}/attach-location`,
//             { locationId: loc._locationId, shopId: loc._shopId, locationDisplayName: loc.name },
//             { headers: authHeaders() }
//           );
//         }
//       }

//       setSets(reconciledSets);
//       setActiveId(savedSetId);
//       setLocationPool(reconciledPool);
//       setSavedSets(reconciledSets);
//       setSavedPool(reconciledPool);
//       showToast(isNewSet ? `"${activeSet.name || "Package set"}" created` : `Saved — changes are live for new purchases`);
//       setViewMode("list");
//     } catch (err) {
//       showToast(`Save failed: ${err?.response?.data?.message || err.message}`);
//     } finally {
//       setSavingSet(false);
//     }
//   };
//   const isNewSet = !!activeSet && String(activeSet.id).startsWith("set-new");
//   const hasChanges = useMemo(() => {
//     try {
//       return (
//         JSON.stringify(sets) !== JSON.stringify(savedSets) ||
//         JSON.stringify(locationPool) !== JSON.stringify(savedPool)
//       );
//     } catch (_) {
//       return true;
//     }
//   }, [sets, locationPool, savedSets, savedPool]);

//   const saveLabel = isNewSet ? "Create package set" : "Save changes";
//   const saveDisabled = isNewSet ? false : !hasChanges;
//   const discardDisabled = !hasChanges;
//   if (loading) return <MonthlyPackagesSkeleton />;
//   if (viewMode === "list" || !activeSet) {
//     return (
//       <div className="mp-app mp-fade-in">
//         <style>{`
//           @keyframes mpFadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
//           .mp-fade-in{ animation: mpFadeIn .22s ease; }
//         `}</style>
//         <TopBar />
//         <LockNotice />
//         <SetsListView
//           sets={sets}
//           locationPool={locationPool}
//           onEdit={handleEditSet}
//           onNewSet={handleNewSet}
//           onDeleteSet={handleDeleteSet}
//         />
//         <ConfirmModal
//           isOpen={!!confirmDeleteId}
//           title="Delete Package Set"
//           message={`Delete "${sets.find((s) => s.id === confirmDeleteId)?.name || "this set"}"? Locations attached to it will become unassigned.`}
//           onConfirm={confirmDeleteSet}
//           onCancel={cancelDeleteSet}
//         />
//         {toast && <div className="mp-toast">{toast}</div>}
//       </div>
//     );
//   }

//   // ---- Edit view: full form for the single set the admin clicked "Edit" on ----
//   return (
//     <div className="mp-app mp-fade-in">
//       <style>{`
//         @keyframes mpFadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
//         .mp-fade-in{ animation: mpFadeIn .22s ease; }
//         .mp-back-btn{
//           display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:9px;
//           border:1px solid #e7e5f2;background:#fff;color:#4b4b5c;font-weight:600;font-size:12.5px;
//           cursor:pointer;transition:background .15s ease, border-color .15s ease;
//         }
//         .mp-back-btn:hover{background:#f5f4fb;border-color:#d9d4ff;}
//       `}</style>
//       <TopBar />
//       <LockNotice />

//       <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
//         <button className="mp-back-btn" onClick={handleBackToList}>
//           ← Back to list
//         </button>
//         <div style={{ fontWeight: 600, fontSize: 15, color: "#222" }}>
//           {isNewSet ? "New package set" : activeSet.name || "Untitled set"}
//         </div>
//       </div>

//       <SetNameAndVehicles set={activeSet} onUpdate={updateActiveSet} />
//       <SingleWashPrice set={activeSet} onUpdate={updateActiveSet} />
//       <PackagesSection set={activeSet} onUpdateSet={updateActiveSet} washTemplates={washTemplates} />
//       <LocationsSection
//         set={activeSet}
//         locationPool={locationPool}
//         onToggleLocation={toggleLocation}
//         onCreateLocation={createLocation}
//       />

//       <FooterBar
//         onDiscard={handleDiscard}
//         onSave={handleSave}
//         saveLabel={saveLabel}
//         saveDisabled={saveDisabled}
//         discardDisabled={discardDisabled}
//         saving={savingSet}
//       />
//       {toast && <div className="mp-toast">{toast}</div>}
//     </div>
//   );
// }
import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { LoadScript } from "@react-google-maps/api";
import Autocomplete from "react-google-autocomplete";
import {
  WASH_COUNT_CATALOG,
  WASH_INCLUDES_OPTIONS,
  initialLocationPool,
  initialSets,
  SUPER_ADMIN_NAME,
  PROVIDER_NAME,
} from "admin/components/pakageSetComp/mockData";
import "./MonthlyPackages.css";

const BASE = "https://production.washta.com/api";
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("accessToken")}` });
const mapConfigToSet = (config) => {
  const snap = (config.serviceNameSnapshot || "").toLowerCase();
  const washIncludes = WASH_INCLUDES_OPTIONS.find((o) => o.toLowerCase() === snap) || config.serviceNameSnapshot || "";
  const shopSvcPrices = config.shopServicePrices || {};
  const refPrices = config.refPrices || {};
  const carTypes = config.carTypes || ["Sedan", "SUV"];
  const singleWashPrice = {};
  carTypes.forEach((ct) => {
    singleWashPrice[ct] = refPrices[ct] ?? shopSvcPrices[ct] ?? "";
  });
  const refPricesFromShop = carTypes.some(
    (ct) => refPrices[ct] === undefined && shopSvcPrices[ct] !== undefined
  );

  return {
    id: config.setId || "set-seller",
    _apiSetId: config.setId || null,
    name: config.setName || "My Packages",
    locked: false,
    washIncludes,
    vehicleTypes: carTypes,
    singleWashPrice,
    shopServicePrices: shopSvcPrices,
    refPricesFromShop,
    packages: (config.tiers || []).map((t) => {
      // Backend stores the total monthly price per tier; the UI works in price-per-wash,
      // so convert once here on load and convert back once on save (see handleSave).
      // A tier with no price saved yet defaults to the single wash price (0% savings)
      // instead of forcing the seller to retype the same number in every package.
      const monthlyPrices = t.prices || {};
      const price = {};
      carTypes.forEach((ct) => {
        const monthly = Number(monthlyPrices[ct]) || 0;
        price[ct] = monthly > 0 && t.washCount > 0 ? monthly / t.washCount : singleWashPrice[ct] ?? "";
      });
      return {
        id: t.tierId || t.templateId,
        washCatalogId: t.templateId,
        washCount: t.washCount,
        frequency: `${t.daysPerWeek}x/week`,
        name: t.defaultDisplayName,
        nameLocked: true,
        on: !!t.isActive,
        popular: !!t.isFeatured,
        price,
      };
    }),
  };
};

const mapApiLocation = (l, setId) => ({
  id: `loc-${l.locationId}`,
  _locationId: String(l.locationId),
  _shopId: String(l.shopId),
  name: l.locationDisplayName || l.city || "Unnamed",
  activePackages: 0,
  setId: l.attachedSetId ? (setId || l.attachedSetId) : null,
});
let uid = 1000;
const nextId = (prefix) => `${prefix}-${uid++}`;

const GOOGLE_MAPS_API_KEY = "AIzaSyDkYZEMg8ZH5EhRqdkLF-GyeHrhpZBlSd0";
const GOOGLE_MAPS_LIBRARIES = ["places"];

function SkeletonBar({ width = "100%", height = 14, style = {} }) {
  return <div className="mp-skel" style={{ width, height, ...style }} />;
}

function MonthlyPackagesSkeleton() {
  return (
    <div className="mp-app">
      {/* Topbar */}
      <div className="mp-topbar">
        <div style={{ flex: 1, minWidth: 240 }}>
          <SkeletonBar width={220} height={22} style={{ marginBottom: 10 }} />
          <SkeletonBar width="min(420px, 90%)" height={13} />
        </div>
        <div className="mp-provider-badge">
          <SkeletonBar width={30} height={30} style={{ borderRadius: "50%" }} />
          <div>
            <SkeletonBar width={90} height={12} style={{ marginBottom: 6 }} />
            <SkeletonBar width={70} height={10} />
          </div>
        </div>
      </div>

      {/* Lock notice */}
      <div className="mp-notice">
        <SkeletonBar width={18} height={18} style={{ borderRadius: 5, flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <SkeletonBar width="92%" height={12} style={{ marginBottom: 8 }} />
          <SkeletonBar width="68%" height={12} />
        </div>
      </div>

      {/* Tabs */}
      <div className="mp-tabs">
        {[0, 1].map((i) => (
          <div key={i} className="mp-tab" style={{ cursor: "default" }}>
            <div style={{ width: "100%" }}>
              <SkeletonBar width={110} height={13} style={{ marginBottom: 8 }} />
              <SkeletonBar width={70} height={10} />
            </div>
          </div>
        ))}
      </div>

      {/* Set name & vehicles */}
      <div className="mp-section">
        <div className="mp-section-grid">
          {[0, 1, 2].map((i) => (
            <div key={i}>
              <SkeletonBar width={100} height={10} style={{ marginBottom: 10 }} />
              <SkeletonBar width="100%" height={38} style={{ borderRadius: 10 }} />
            </div>
          ))}
        </div>
      </div>

      {/* Single wash price */}
      <div className="mp-section tint">
        <SkeletonBar width={230} height={15} style={{ marginBottom: 8 }} />
        <SkeletonBar width="min(340px, 90%)" height={12} style={{ marginBottom: 18 }} />
        <div className="mp-price-row">
          {[0, 1].map((i) => (
            <div key={i} className="mp-price-field">
              <SkeletonBar width={46} height={13} />
              <SkeletonBar width={120} height={36} style={{ borderRadius: 10 }} />
            </div>
          ))}
        </div>
      </div>

      {/* Packages & price */}
      <div className="mp-section">
        <div className="mp-packages-header">
          <SkeletonBar width={170} height={11} />
          <SkeletonBar width={140} height={34} style={{ borderRadius: 10 }} />
        </div>
        <div className="mp-packages-grid">
          {[0, 1, 2].map((i) => (
            <div key={i} className="mp-package-card">
              <div className="mp-package-card-top">
                <div style={{ flex: 1 }}>
                  <SkeletonBar width={110} height={14} style={{ marginBottom: 8 }} />
                  <SkeletonBar width={80} height={11} />
                </div>
                <SkeletonBar width={38} height={22} style={{ borderRadius: 999 }} />
              </div>
              <SkeletonBar width={90} height={10} style={{ margin: "16px 0 8px" }} />
              <SkeletonBar width="100%" height={36} style={{ borderRadius: 10, marginBottom: 14 }} />
              <SkeletonBar width={110} height={10} style={{ marginBottom: 8 }} />
              <SkeletonBar width="100%" height={36} style={{ borderRadius: 10, marginBottom: 12 }} />
              <SkeletonBar width="60%" height={10} />
            </div>
          ))}
        </div>
      </div>

      {/* Locations */}
      <div className="mp-section">
        <SkeletonBar width={280} height={15} style={{ marginBottom: 16 }} />
        <SkeletonBar width="min(340px, 100%)" height={38} style={{ borderRadius: 10 }} />
      </div>
    </div>
  );
}

/* -------------------- Class: TopBar -------------------- */
/** @author Super Admin — Ahmed Raza */
function TopBar() {
  return (
    <div className="mp-topbar">
      <div>
        <h1 className="h1-all-heading">Monthly Packages</h1>
        <p className="mp-subtitle">
          A package set is a price card. Build it once, then attach every location that should
          use those prices — you don't configure each building separately.
        </p>
      </div>
      {/* <div className="mp-provider-badge">
        <div className="mp-provider-avatar">{PROVIDER_NAME[0]}</div>
        <div className="mp-provider-meta">
          <div className="mp-provider-name">{PROVIDER_NAME}</div>
          <div className="mp-provider-role">Provider console</div>
        </div>
      </div> */}
    </div>
  );
}

/* -------------------- Class: LockNotice -------------------- */
/** @author Super Admin — Ahmed Raza */
function LockNotice() {
  return (
    <div className="mp-notice">
      <span>🔒</span>
      <div>
        <b>Wash counts are set by Washta and are the same for every provider.</b> The name shown
        in the app comes from Washta too — you choose which packages to switch on and what to
        charge. Each count is tied to a weekly frequency — a customer on the 8-wash package picks
        exactly 2 preferred days.
      </div>
    </div>
  );
}
function SetsListView({ sets, locationPool, onEdit, onNewSet, onDeleteSet }) {
  const countLocations = (setId) => locationPool.filter((l) => l.setId === setId).length;
  const countActivePackages = (set) => set.packages.filter((p) => p.on && !p._deleted).length;
  const initials = (name) => (name || "?").trim().charAt(0).toUpperCase() || "?";

  return (
    <div className="mp-section">
      <style>{`
        .mp-list-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;}
        .mp-sets-grid{display:grid;grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));gap:14px;}
        .mp-set-card{
          position:relative;display:flex;flex-direction:column;gap:14px;
          padding:18px 18px 16px;border-radius:16px;background:#fff;
          border:1px solid #ececf3;
          box-shadow:0 1px 2px rgba(20,20,43,0.04);
          transition:box-shadow .18s ease, transform .18s ease, border-color .18s ease;
        }
        .mp-set-card:hover{
          box-shadow:0 10px 24px rgba(107,95,228,0.12);
          border-color:#d9d4ff;
          transform:translateY(-2px);
        }
        .mp-set-card-top{display:flex;align-items:center;gap:12px;}
        .mp-set-avatar{
          width:40px;height:40px;border-radius:12px;flex-shrink:0;
          display:flex;align-items:center;justify-content:center;
          background:linear-gradient(135deg,#7c6cf5,#6b5fe4);
          color:#fff;font-weight:700;font-size:15px;
        }
        .mp-set-name{font-weight:600;font-size:14.5px;color:#1c1c28;line-height:1.3;
          overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
        .mp-set-service{font-size:11.5px;color:#8b8b9e;margin-top:2px;
          overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
        .mp-set-stats{display:flex;gap:8px;flex-wrap:wrap;}
        .mp-set-stat{
          display:flex;align-items:center;gap:5px;font-size:11.5px;color:#5b5b6e;
          background:#f5f4fb;border-radius:999px;padding:5px 10px;font-weight:500;
        }
        .mp-set-stat b{color:#1c1c28;font-weight:700;}
        .mp-set-card-actions{display:flex;align-items:center;gap:8px;margin-top:2px;}
        .mp-set-edit-btn{
          flex:1;text-align:center;padding:9px 14px;border-radius:10px;
          background:#6b5fe4;color:#fff;font-weight:600;font-size:12.5px;
          border:none;cursor:pointer;transition:background .15s ease, transform .1s ease;
        }
        .mp-set-edit-btn:hover{background:#5b4fd9;}
        .mp-set-edit-btn:active{transform:scale(0.97);}
        .mp-set-delete-btn{
          width:36px;height:36px;border-radius:10px;border:1px solid #f0d9d9;
          background:#fff5f5;color:#d95b5b;display:flex;align-items:center;justify-content:center;
          cursor:pointer;flex-shrink:0;transition:background .15s ease, border-color .15s ease;
        }
        .mp-set-delete-btn:hover{background:#ffe3e3;border-color:#f3b8b8;}
        .mp-sets-empty{
          text-align:center;padding:56px 20px;color:#9a9aac;font-size:13px;
          border:1.5px dashed #e3e1f2;border-radius:16px;background:#faf9ff;
        }
        .mp-new-set-btn{
          display:inline-flex;align-items:center;gap:6px;padding:10px 18px;border-radius:10px;
          background:#6b5fe4;color:#fff;font-weight:600;font-size:13px;border:none;cursor:pointer;
          transition:background .15s ease, transform .1s ease;
        }
        .mp-new-set-btn:hover{background:#5b4fd9;}
        .mp-new-set-btn:active{transform:scale(0.97);}
      `}</style>

      <div className="mp-list-header">
        <div>
          <div className="mp-eyebrow">Your package sets</div>
          <div className="mp-hint" style={{ marginTop: 2 }}>
            {sets.length} set{sets.length === 1 ? "" : "s"} · click Edit to change prices or packages
          </div>
        </div>
        <button className="mp-new-set-btn" onClick={onNewSet}>
          <span style={{ fontSize: 15, lineHeight: 1 }}>+</span> New set
        </button>
      </div>

      {sets.length === 0 ? (
        <div className="mp-sets-empty">
          No package sets yet — click <b style={{ color: "#6d5bf0" }}>+ New set</b> to create your first one.
        </div>
      ) : (
        <div className="mp-sets-grid">
          {sets.map((s) => (
            <div key={s.id} className="mp-set-card">
              <div className="mp-set-card-top">
                <div className="mp-set-avatar">{initials(s.name)}</div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div className="mp-set-name">{s.name || "Untitled set"}</div>
                  <div className="mp-set-service">{s.washIncludes || "No service selected"}</div>
                </div>
              </div>

              <div className="mp-set-stats">
                <span className="mp-set-stat">
                  <b>{countActivePackages(s)}</b> active packages
                </span>
                <span className="mp-set-stat">
                  <b>{countLocations(s.id)}</b> locations
                </span>
              </div>

              <div className="mp-set-card-actions">
                <button className="mp-set-edit-btn" onClick={() => onEdit(s.id)}>
                  ✎ Edit
                </button>
                <button
                  className="mp-set-delete-btn"
                  title="Delete this package set"
                  onClick={() => onDeleteSet(s.id)}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                    <path d="M10 11v6" />
                    <path d="M14 11v6" />
                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* -------------------- Class: SetNameAndVehicles -------------------- */
/** @author Super Admin — Ahmed Raza */
function SetNameAndVehicles({ set, onUpdate }) {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customName, setCustomName] = useState("");

  const toggleVehicle = (type) => {
    if (set.locked) return;
    const active = set.vehicleTypes.includes(type);
    let vehicleTypes;
    let singleWashPrice = { ...set.singleWashPrice };
    let packages = set.packages;
    if (active) {
      vehicleTypes = set.vehicleTypes.filter((v) => v !== type);
    } else {
      vehicleTypes = [...set.vehicleTypes, type];
      if (singleWashPrice[type] === undefined) singleWashPrice[type] = "";
      packages = packages.map((p) => ({
        ...p,
        price: { ...p.price, [type]: p.price[type] ?? "" },
      }));
    }
    onUpdate({ ...set, vehicleTypes, singleWashPrice, packages });
  };

  const removeCustomVehicle = (type) => {
    const vehicleTypes = set.vehicleTypes.filter((v) => v !== type);
    const singleWashPrice = { ...set.singleWashPrice };
    delete singleWashPrice[type];
    const packages = set.packages.map((p) => {
      const price = { ...p.price };
      delete price[type];
      return { ...p, price };
    });
    onUpdate({ ...set, vehicleTypes, singleWashPrice, packages });
  };

  const addCustomVehicle = () => {
    const name = customName.trim();
    if (!name || set.vehicleTypes.includes(name)) return;
    onUpdate({
      ...set,
      vehicleTypes: [...set.vehicleTypes, name],
      singleWashPrice: { ...set.singleWashPrice, [name]: "" },
      packages: set.packages.map((p) => ({ ...p, price: { ...p.price, [name]: "" } })),
    });
    setCustomName("");
    setShowCustomInput(false);
  };

  const isDefault = (type) => type === "Sedan" || type === "SUV";

  return (
    <div className="mp-section">
      <div className="mp-section-grid">
        <div>
          <div className="mp-field-label">Set name</div>
          <input
            className="mp-input"
            value={set.name}
            placeholder="e.g. Standard Packages"
            onChange={(e) => onUpdate({ ...set, name: e.target.value })}
          />
          <div className="mp-hint">Your own label — customers never see this</div>
        </div>

        <div>
          <div className="mp-field-label">What one wash in this package includes</div>
          <select
            className="mp-select"
            value={set.washIncludes}
            disabled={set.locked}
            onChange={(e) => onUpdate({ ...set, washIncludes: e.target.value })}
          >
            <option value="">Select...</option>
            {WASH_INCLUDES_OPTIONS.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
          <div className="mp-hint">
            Every package in this set delivers this service.{" "}
            {set.locked ? "Locked once the first package is sold." : "Editable until first sale."}
          </div>
        </div>

        <div>
          <div className="mp-field-label">Car types</div>
          <div className="mp-cartype-row">
            {["Sedan", "SUV"].map((type) => {
              const checked = set.vehicleTypes.includes(type);
              return (
                <div
                  key={type}
                  className={`mp-cartype-chip ${checked ? "checked" : ""}`}
                  onClick={() => toggleVehicle(type)}
                >
                  <span className="box">{checked ? "✓" : ""}</span>
                  {type}
                </div>
              );
            })}
            {set.vehicleTypes
              .filter((t) => !isDefault(t))
              .map((type) => (
                <div key={type} className="mp-cartype-chip checked">
                  <span className="box">✓</span>
                  {type}
                  <span
                    className="remove"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeCustomVehicle(type);
                    }}
                  >
                    ×
                  </span>
                </div>
              ))}
            {!showCustomInput && (
              <button className="mp-add-custom-btn" onClick={() => setShowCustomInput(true)}>
                + Add custom
              </button>
            )}
          </div>
          {showCustomInput && (
            <div className="mp-custom-input-row">
              <input
                className="mp-input"
                placeholder="e.g. Pickup Truck"
                value={customName}
                autoFocus
                onChange={(e) => setCustomName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && addCustomVehicle()}
              />
              <button className="mp-btn violet" onClick={addCustomVehicle}>
                Add
              </button>
              <button className="mp-btn" onClick={() => setShowCustomInput(false)}>
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* -------------------- Class: SingleWashPrice -------------------- */
/** @author Super Admin — Ahmed Raza */
function SingleWashPrice({ set, onUpdate }) {
  const updatePrice = (type, value) => {
    const newSingle = Number(value) || 0;
    const oldSingle = Number(set.singleWashPrice[type]) || 0;
    const updatedPackages = set.packages.map((p) => {
      const currentPrice = Number(p.price[type]) || 0;
      const wasAutoFilled = oldSingle > 0 ? currentPrice === oldSingle : currentPrice === 0;
      if (!wasAutoFilled) return p; 
      return {
        ...p,
        price: { ...p.price, [type]: newSingle > 0 ? newSingle : "" },
      };
    });
    onUpdate({ ...set, singleWashPrice: { ...set.singleWashPrice, [type]: value }, packages: updatedPackages });
  };
  return (
    <div className="mp-section tint">
      <h3 className="mp-section-title">Single wash price at these locations</h3>
      <p className="mp-section-desc">
        What one wash costs if a customer buys it on its own, not in a package. Savings below are
        calculated from this.
      </p>
      <div className="mp-price-row">
        {set.vehicleTypes.map((type) => (
          <div className="mp-price-field" key={type}>
            <span className="veh-label">{type}</span>
            <div className="mp-aed-input">
              <span className="prefix">AED</span>
              <input
              min="1"
                onWheel={(e) => e.target.blur()}
                type="number"
                value={set.singleWashPrice[type] ?? ""}
                onChange={(e) => updatePrice(type, e.target.value)}
              />
            </div>
          </div>
        ))}
        {set.vehicleTypes.length === 0 && (
          <span className="mp-hint">Add a car type above first.</span>
        )}
      </div>
    </div>
  );
}

/* -------------------- Class: PackageCard -------------------- */
/** @author Super Admin — Ahmed Raza */
function PackageCard({ pkg, set, onUpdate, onDelete, onSetPopular }) {
  const [editingName, setEditingName] = useState(false);

  // The card's input edits the monthly total (what the customer pays for the
  // whole package) — everything else (pkg.price, savings %, save-to-backend)
  // still works in price-per-wash, so convert on the way in and out.
  const updateMonthlyPrice = (type, value) => {
    if (value === "") {
      onUpdate({ ...pkg, price: { ...pkg.price, [type]: "" } });
      return;
    }
    const monthly = Number(value);
    const perWash = pkg.washCount > 0 ? monthly / pkg.washCount : monthly;
    onUpdate({ ...pkg, price: { ...pkg.price, [type]: perWash } });
  };

  return (
    <div className={`mp-package-card ${pkg.popular ? "selected" : ""}`}>
      <div className="mp-package-card-top">
        <div>
          <div className="mp-package-title">{pkg.name}</div>
          <div className="mp-package-freq">
            <span className="lock">🔒</span>
            {pkg.frequency} · set by Washta
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button
            className={`mp-toggle ${pkg.on ? "on" : ""}`}
            onClick={() => onUpdate({ ...pkg, on: !pkg.on })}
          >
            <span className="dot" />
          </button>
          <button
            className="mp-icon-btn danger"
            title="Delete package"
            style={{ marginLeft: 2 }}
            onClick={() => onDelete(pkg.id)}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
              <path d="M10 11v6"/><path d="M14 11v6"/>
              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
            </svg>
          </button>
        </div>
      </div>

      {pkg.popular && <div className="mp-popular-tag" style={{ marginTop: 10 }}>⭐ Popular</div>}

      <div className="mp-package-field-label">
        Name shown in app{" "}
        {!editingName && <span className="mp-tiny-tag">SET BY WASHTA</span>}
      </div>
      <div className="mp-name-row">
        <input
          className="mp-input"
          value={pkg.name}
          disabled={!editingName}
          onChange={(e) => onUpdate({ ...pkg, name: e.target.value })}
        />
        <button className="mp-icon-btn" title="Edit name" onClick={() => setEditingName((v) => !v)}>
          ✎
        </button>
      </div>

      <div className="mp-package-field-label">Total price per month (AED)</div>
      {set.vehicleTypes.map((type) => {
        const perWash = pkg.price[type];
        const monthlyValue =
          perWash === "" || perWash === undefined || perWash === null || Number.isNaN(Number(perWash))
            ? ""
            : Math.round(Number(perWash) * (pkg.washCount || 0) * 100) / 100;
        return (
          <div key={type}>
            <div className="mp-package-price-row">
              <span className="veh">{type}</span>
              <div className="mp-aed-input">
                <span className="prefix">AED</span>
                <input
                  type="number"
                  value={monthlyValue}
                  onChange={(e) => updateMonthlyPrice(type, e.target.value)}
                />
              </div>
            </div>
          </div>
        );
      })}

      <div className="mp-package-summary">
        {set.vehicleTypes
          .map((type) => {
            const perWash = Number(pkg.price[type]) || 0;
            const monthlyTotal = perWash * (pkg.washCount || 0);
            return perWash > 0 ? `${type} AED ${perWash.toFixed(2)}/wash (AED ${monthlyTotal.toFixed(2)}/mo)` : null;
          })
          .filter(Boolean)
          .join(" · ")}
      </div>
      <div className="mp-package-savings">
        {set.vehicleTypes
          .map((type) => {
            const perWash = Number(pkg.price[type]) || 0;
            const refPrice = Number(set.shopServicePrices?.[type]) || Number(set.singleWashPrice[type]) || 0;
            if (!(refPrice > 0 && perWash > 0 && pkg.washCount > 0)) return null;
            const fullPrice = refPrice * pkg.washCount;
            const packageTotal = perWash * pkg.washCount;
            const pct = ((fullPrice - packageTotal) / fullPrice) * 100;
            return `${pct >= 0 ? "Saves" : "Costs"} ${Math.abs(pct).toFixed(1)}% ${type}`;
          })
          .filter(Boolean)
          .join(" · ")}
      </div>

      <div className="mp-package-footer">
        <label className="mp-radio-row">
          <input
            type="radio"
            name={`popular-${set.id}`}
            checked={pkg.popular}
            onChange={() => onSetPopular(pkg.id)}
          />
          Show "Popular" badge
        </label>
      </div>
    </div>
  );
}

/* -------------------- Class: PackagesSection -------------------- */
/** @author Super Admin — Ahmed Raza */
function PackagesSection({ set, onUpdateSet, washTemplates }) {
  const availableToAdd = washTemplates.filter(
    (c) => !set.packages.some((p) => p.washCatalogId === c.id && !p._deleted)
  );

  const addPackage = (catalogId) => {
    if (!catalogId) return;
    const catalog = washTemplates.find((c) => c.id === catalogId);
    if (!catalog) return;
    const price = {};
    set.vehicleTypes.forEach((t) => {
      const single = Number(set.singleWashPrice[t]) || 0;
      price[t] = single > 0 ? single : "";
    });
    const newPkg = {
      id: nextId("pkg"),
      washCatalogId: catalog.id,
      washCount: catalog.washCount,
      frequency: catalog.frequency,
      name: catalog.defaultName,
      nameLocked: true,
      on: true,
      popular: set.packages.length === 0,
      price,
    };
    onUpdateSet({ ...set, packages: [...set.packages, newPkg] });
  };

  const updatePackage = (updated) => {
    onUpdateSet({ ...set, packages: set.packages.map((p) => (p.id === updated.id ? updated : p)) });
  };

  const deletePackage = (id) => {
    onUpdateSet({ ...set, packages: set.packages.map((p) => p.id === id ? { ...p, on: false, _deleted: true } : p) });
  };

  const setPopular = (id) => {
    onUpdateSet({
      ...set,
      packages: set.packages.map((p) => ({ ...p, popular: p.id === id })),
    });
  };

  return (
    <div className="mp-section">
      <div className="mp-packages-header">
        <div className="mp-eyebrow">Packages &amp; monthly price</div>
        <select
          className="mp-add-package-select"
          value=""
          onChange={(e) => addPackage(e.target.value)}
        >
          <option value="">+ Add package</option>
          {availableToAdd.map((c) => (
            <option key={c.id} value={c.id}>
              {c.defaultName}
            </option>
          ))}
        </select>
      </div>

      {set.packages.length === 0 || set.packages.every((p) => p._deleted) ? (
        <div className="mp-empty-packages">
          No packages yet — pick a wash count from "+ Add package" above.
        </div>
      ) : (
        <div className="mp-packages-grid">
          {set.packages.filter((pkg) => !pkg._deleted).map((pkg) => (
            <PackageCard
              key={pkg.id}
              pkg={pkg}
              set={set}
              onUpdate={updatePackage}
              onDelete={deletePackage}
              onSetPopular={setPopular}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function LocationsSection({ set, locationPool, onToggleLocation, onCreateLocation }) {
  const [showCreate, setShowCreate] = useState(false);
  const [placeQuery, setPlaceQuery] = useState("");
  const [pickedPlace, setPickedPlace] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [selectedLocId, setSelectedLocId] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const autocompleteRef = useRef(null);

  const activeTierCount = set.packages.filter((p) => p.on).length;
  const attachedLocations = locationPool.filter((l) => l.setId === set.id);
  const availableLocations = locationPool.filter((l) => !l.setId);

  // auto-select first attached location
  useEffect(() => {
    if (attachedLocations.length && !attachedLocations.find((l) => l.id === selectedLocId)) {
      setSelectedLocId(attachedLocations[0].id);
    }
  }, [attachedLocations]);

  // close menu on outside click
  useEffect(() => {
    const handler = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const selectedLoc = attachedLocations.find((l) => l.id === selectedLocId) || attachedLocations[0] || null;

  const handleAddFromDropdown = (e) => {
    const locId = e.target.value;
    if (!locId) return;
    onToggleLocation(locId, set.id);
    e.target.value = "";
  };

  const handlePlaceSelected = (place) => {
    const lat = typeof place?.geometry?.location?.lat === "function" ? place.geometry.location.lat() : place?.geometry?.location?.lat ?? null;
    const lng = typeof place?.geometry?.location?.lng === "function" ? place.geometry.location.lng() : place?.geometry?.location?.lng ?? null;
    setPickedPlace({ lat, lng, formattedAddress: place?.formatted_address || "", placeId: place?.place_id || null });
    setPlaceQuery(place?.formatted_address || place?.name || "");
  };

  const resetCreateForm = () => { setPlaceQuery(""); setPickedPlace(null); setDisplayName(""); };

  const handleAddLocation = () => {
    const name = displayName.trim();
    if (!name) return;
    onCreateLocation(name, pickedPlace || {});
    resetCreateForm();
    setShowCreate(false);
  };

  const canAdd = displayName.trim().length > 0;

  return (
    <div className="mp-section">
      <div className="mp-loc-header">
        <div className="mp-loc-title-row">
          📍 Locations using this set{" "}
          <span className="mp-loc-desc">— pick from the dropdown to add, or create a package-only location</span>
        </div>
      </div>

      <div className="mp-loc-add-dropdown-row">
        <select className="mp-select" value="" onChange={(e) => {
          const val = e.target.value;
          if (val === "__create__") {
            setShowCreate((v) => !v);
            if (showCreate) resetCreateForm();
          } else if (val) {
            onToggleLocation(val, set.id);
          }
          e.target.value = "";
        }}>
          <option value="">+ Add location...</option>
          <option value="__create__">Create a package-only location</option>
          {availableLocations.length > 0 && (
            <optgroup label="Existing locations">
              {availableLocations.map((loc) => (
                <option key={loc.id} value={loc.id}>{loc.name}</option>
              ))}
            </optgroup>
          )}
        </select>
        {availableLocations.length === 0 && (
          <span className="mp-hint">No unassigned locations left — create a new one.</span>
        )}
      </div>

      {showCreate && (
        <div className="mp-loc-create-card">
          <div>
            <div className="mp-field-label">Search building / address (for map pin)</div>
            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
              <Autocomplete
                ref={autocompleteRef}
                onPlaceSelected={handlePlaceSelected}
                options={{ types: ["establishment", "geocode"], componentRestrictions: { country: "AE" } }}
                fields={["name", "formatted_address", "geometry", "place_id"]}
                value={placeQuery}
                onChange={(e) => setPlaceQuery(e.target.value)}
                placeholder="Search for a building / address in UAE"
                className="mp-input"
                style={{ width: "100%" }}
              />
            </LoadScript>
            {pickedPlace && (
              <div className="mp-loc-pinned-badge">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#6b5fe4" strokeWidth="2.5" strokeLinecap="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                Pinned{pickedPlace.formattedAddress ? ` — ${pickedPlace.formattedAddress}` : ""}
              </div>
            )}
          </div>
          <div>
            <div className="mp-field-label">Display location name</div>
            <input
              className="mp-input"
              placeholder="e.g. Marina Heights Tower B"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && canAdd && handleAddLocation()}
            />
            <div className="mp-hint">Customers see this name — not the searched address.</div>
          </div>
          <div className="mp-loc-create-actions">
            <button className="mp-btn violet" disabled={!canAdd} onClick={handleAddLocation}>Add location</button>
            <button className="mp-btn" onClick={() => { setShowCreate(false); resetCreateForm(); }}>Cancel</button>
          </div>
        </div>
      )}

      {attachedLocations.length === 0 ? (
        <div className="mp-empty-packages">No locations attached yet — add one from the dropdown above.</div>
      ) : (
        <div className="mp-loc-dropdown-wrap" ref={menuRef}>
          {/* Trigger */}
          <button
            type="button"
            className={`mp-loc-trigger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span className="mp-loc-pin">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6B5FE4" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            </span>
            <span className="mp-loc-trigger-value">
              {selectedLoc ? selectedLoc.name : `${attachedLocations.length} locations`}
            </span>
            <span className="mp-loc-count-badge">{attachedLocations.length}</span>
            <span className={`mp-loc-arrow ${menuOpen ? "open" : ""}`}>
              <svg width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" stroke="#6B5FE4" strokeWidth="1.5" fill="none" strokeLinecap="round"/></svg>
            </span>
          </button>

          {/* Delete button — same style as shop delete */}
          {selectedLoc && (
            <button
              type="button"
              className="mp-loc-delete-btn"
              title={`Remove ${selectedLoc.name}`}
              onClick={() => { onToggleLocation(selectedLoc.id, set.id); setSelectedLocId(""); setMenuOpen(false); }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6"/><path d="M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          )}

          {/* Dropdown menu */}
          {menuOpen && (
            <div className="mp-loc-menu">
              {attachedLocations.map((loc, i) => (
                <button
                  key={loc.id}
                  type="button"
                  className={`mp-loc-item ${selectedLocId === loc.id ? "active" : ""}`}
                  style={{ animationDelay: `${i * 0.03}s` }}
                  onClick={() => { setSelectedLocId(loc.id); setMenuOpen(false); }}
                >
                  <span className="mp-loc-item-dot" />
                  <span className="mp-loc-item-label">{loc.name}</span>
                  <span className="mp-loc-item-sub">{activeTierCount} active packages</span>
                  {selectedLocId === loc.id && (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6B5FE4" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="mp-single-wash-note">
        ✓ Single-wash service stays available at these locations. Customers choose a one-off wash or a monthly package at checkout.
      </div>
    </div>
  );
}
function FooterBar({ onDiscard, onSave, saveLabel = "Save all changes", saveDisabled = false, discardDisabled = false, saving = false }) {
  return (
    <div className="mp-footer-bar">
      <div className="mp-footer-note">
        Price changes apply to new purchases — packages already running keep the price they were
        bought at
      </div>
      <div className="mp-footer-actions">
        <button className="mp-btn" onClick={onDiscard} disabled={discardDisabled || saving} title={discardDisabled ? "No changes to discard" : ""}>
          Discard
        </button>
        <button
          className="mp-btn violet"
          onClick={onSave}
          disabled={saveDisabled || saving}
          title={saveDisabled ? "Change something first" : ""}
        >
          {saving && <span className="mp-btn-spinner" />}
          {saving ? "Saving…" : saveLabel}
        </button>
      </div>
    </div>
  );
}

/* -------------------- Class: ConfirmModal -------------------- */
/** @author Super Admin — Ahmed Raza */
function ConfirmModal({ isOpen, title, message, onConfirm, onCancel }) {
  // The page sidebar (`.div-sidebar`) is shared/global CSS used across many routes,
  // so its rendered edge can't be assumed from a fixed pixel value here — measure it
  // live so the overlay starts exactly where the sidebar ends (0 when it's off-canvas).
  const [contentLeft, setContentLeft] = useState(0);

  useEffect(() => {
    if (!isOpen) return;
    const sidebarEl = document.querySelector(".div-sidebar");
    setContentLeft(sidebarEl ? Math.max(0, sidebarEl.getBoundingClientRect().right) : 0);
  }, [isOpen]);

  if (!isOpen) return null;
  return (
    <div className="mp-confirm-overlay"  onClick={onCancel}>
      <div className="mp-confirm-box" onClick={(e) => e.stopPropagation()}>
        <div className="mp-confirm-title">{title}</div>
        <div className="mp-confirm-message">{message}</div>
        <div className="mp-confirm-actions">
          <button className="mp-confirm-btn cancel" onClick={onCancel}>Cancel</button>
          <button className="mp-confirm-btn delete" onClick={onConfirm}>Yes, Delete</button>
        </div>
      </div>
    </div>
  );
}

/* -------------------- Class: MonthlyPackagesPage (root) -------------------- */
/** @author Super Admin — Ahmed Raza
 *  @param {Array} myLocations - raw location records from
 *  `${BASE}/residential/seller/my-locations` (fetched by the parent Packages
 *  page and passed down as a prop). When present, these seed/refresh the
 *  location pool that both the dropdown and the location cards read from.
 */
export default function MonthlyPackagesPage({ myLocations = [] }) {
  const [sets, setSets] = useState([]);
  const [locationPool, setLocationPool] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [savedSets, setSavedSets] = useState([]);
  const [savedPool, setSavedPool] = useState([]);
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);
  const [washTemplates, setWashTemplates] = useState([]);
  const [apiSetId, setApiSetId] = useState(null);
  const [shopServicePrices, setShopServicePrices] = useState({});
  const [viewMode, setViewMode] = useState("list");
  const [savingSet, setSavingSet] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  // Fetch real data on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [setsRes, locsRes] = await Promise.all([
          axios.get(`${BASE}/package-sets/seller/my-sets`, { headers: authHeaders() }),
          axios.get(`${BASE}/package-sets/seller/my-locations`, { headers: authHeaders() }),
        ]);
        const { sets: apiSets = [], shopServicePrices: shopPrices = {} } = setsRes.data.data || {};

        // Templates from first set's tiers, or fallback fetch
        let templates = apiSets[0]?.tiers?.map((t) => ({
          id: t.templateId, washCount: t.washCount,
          frequency: `${t.daysPerWeek}x/week`, defaultName: t.defaultDisplayName,
        })) || [];

        if (!templates.length) {
          try {
            const tplRes = await axios.get(`${BASE}/package-sets/seller/tier-templates`, { headers: authHeaders() });
            templates = (tplRes.data.data || []).filter((t) => t.isActive !== false).map((t) => ({
              id: String(t._id), washCount: t.washCount,
              frequency: `${t.daysPerWeek}x/week`, defaultName: t.defaultDisplayName,
            }));
          } catch (_) {}
        }
        if (templates.length) setWashTemplates(templates);
        setShopServicePrices(shopPrices);

        if (apiSets.length) {
          const mappedSets = apiSets.map((config) => mapConfigToSet({ ...config, shopServicePrices: shopPrices }));
          setSets(mappedSets);
          setSavedSets(mappedSets);
          setActiveId(mappedSets[0]?.id || null);
          // keep apiSetId as the last set's id for backward compat (single-set flows)
          setApiSetId(mappedSets[mappedSets.length - 1]?.id || null);
        }

        // Locations
        const rawLocs = locsRes.data.data || locsRes.data || [];
        const apiLocs = (Array.isArray(rawLocs) ? rawLocs : []).map((l) => ({
          id: `loc-${l.locationId}`,
          _locationId: String(l.locationId),
          _shopId: String(l.shopId),
          name: l.locationDisplayName || l.city || "Unnamed",
          activePackages: l.activePackages || 0,
          setId: l.attachedSetId || null,
        }));
        setLocationPool(apiLocs);
        setSavedPool(apiLocs);
      } catch (err) {
        console.error("MonthlyPackagesPage fetch error:", err?.response?.data || err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(null), 2600);
  };

  const activeSet = sets.find((s) => s.id === activeId);

  const updateActiveSet = (updated) => {
    setSets((prev) => prev.map((s) => (s.id === updated.id ? updated : s)));
  };
  const handleNewSet = () => {
    const id = nextId("set-new");
    const vehicleTypes = ["Sedan", "SUV"];

    const singleWashPrice = {};
    vehicleTypes.forEach((t) => {
      singleWashPrice[t] = shopServicePrices[t] ?? "";
    });

    const draft = {
      id,
      name: "",
      locked: false,
      washIncludes: "",
      vehicleTypes,
      singleWashPrice,
      shopServicePrices,
      refPricesFromShop: Object.keys(shopServicePrices).length > 0,
      packages: washTemplates.map((t) => {
        const price = {};
        vehicleTypes.forEach((vt) => {
          const single = Number(singleWashPrice[vt]) || 0;
          price[vt] = single > 0 ? single : "";
        });
        return {
          id: t.id,
          washCatalogId: t.id,
          washCount: t.washCount,
          frequency: t.frequency,
          name: t.defaultName,
          nameLocked: true,
          on: false,
          popular: false,
          price,
        };
      }),
    };
    setSets((prev) => [...prev, draft]);
    setActiveId(id);
    setViewMode("edit");
  };

  const handleEditSet = (id) => {
    setActiveId(id);
    setViewMode("edit");
  };

  const handleBackToList = () => {
    // "New Set" pushes an unsaved draft into `sets` immediately (see handleNewSet).
    // If the user never actually saved it, going back must drop that draft —
    // otherwise a ghost "Untitled set" card lingers in the list until a page refresh.
    if (activeId && String(activeId).startsWith("set-new")) {
      setSets((prev) => prev.filter((s) => s.id !== activeId));
    }
    setViewMode("list");
  };

  const handleDeleteSet = (id) => {
    setConfirmDeleteId(id);
  };

  const cancelDeleteSet = () => setConfirmDeleteId(null);

  const confirmDeleteSet = async () => {
    const id = confirmDeleteId;
    setConfirmDeleteId(null);
    const setToDelete = sets.find((s) => s.id === id);

    // If this is a saved API set, delete from backend too
    const realSetId = setToDelete?._apiSetId || (String(setToDelete?.id).match(/^[a-f\d]{24}$/i) ? setToDelete.id : null);
    if (realSetId) {
      try {
        await axios.delete(`${BASE}/package-sets/seller/${realSetId}`, { headers: authHeaders() });
      } catch (err) {
        showToast(`Delete failed: ${err?.response?.data?.message || err.message}`);
        return;
      }
    }

    const remaining = sets.filter((s) => s.id !== id);
    setSets(remaining);
    setSavedSets(remaining);

    // Backend ne locations detach kar diye — fresh fetch karo taake purani locations na dikhen
    try {
      const locsRes = await axios.get(`${BASE}/package-sets/seller/my-locations`, { headers: authHeaders() });
      const rawLocs = locsRes.data.data || locsRes.data || [];
      const freshLocs = (Array.isArray(rawLocs) ? rawLocs : []).map((l) => ({
        id: `loc-${l.locationId}`,
        _locationId: String(l.locationId),
        _shopId: String(l.shopId),
        name: l.locationDisplayName || l.city || "Unnamed",
        activePackages: l.activePackages || 0,
        setId: l.attachedSetId || null,
      }));
      setLocationPool(freshLocs);
      setSavedPool(freshLocs);
    } catch (_) {
      setLocationPool((prev) => prev.map((l) => (l.setId === id ? { ...l, setId: null } : l)));
      setSavedPool((prev) => prev.map((l) => (l.setId === id ? { ...l, setId: null } : l)));
    }

    if (activeId === id) {
      setActiveId(remaining[0]?.id || null);
      setViewMode("list");
    }
    showToast(`"${setToDelete?.name || "Set"}" deleted`);
  };

  const toggleLocation = (locId, setId) => {
    setLocationPool((prev) =>
      prev.map((l) => {
        if (l.id !== locId) return l;
        return { ...l, setId: l.setId === setId ? null : setId };
      })
    );
  };

  const createLocation = async (name, coords = {}) => {
    try {
      const res = await axios.post(
        `${BASE}/package-sets/seller/create-location`,
        { displayName: name, lat: coords.lat, lng: coords.lng, text: coords.formattedAddress || name, setId: activeSet._apiSetId || undefined },
        { headers: authHeaders() }
      );
      const created = res.data.data || res.data;
      const id = nextId("loc-new");
      setLocationPool((prev) => [
        ...prev,
        {
          id,
          _locationId: String(created.locationId),
          _shopId: String(created.shopId),
          name,
          activePackages: 0,
          setId: activeSet.id,
        },
      ]);
      showToast(`Location "${name}" created`);
    } catch (err) {
      showToast(`Failed to create location: ${err?.response?.data?.message || err.message}`);
    }
  };

  const handleDiscard = () => {
    setSets(savedSets);
    setLocationPool(savedPool);
    if (!savedSets.some((s) => s.id === activeId)) {
      setActiveId(savedSets[0]?.id || null);
    }
    setViewMode("list");
    showToast("Changes discarded");
  };

  const handleSave = async () => {
    setSavingSet(true);
    try {
      const activePkgs = activeSet.packages.filter((p) => p.on);
      if (activePkgs.length > 0 && !activePkgs.some((p) => p.popular)) {
        const firstActiveId = activePkgs[0].id;
        updateActiveSet({
          ...activeSet,
          packages: activeSet.packages.map((p) => ({ ...p, popular: p.id === firstActiveId })),
        });
        showToast("One package must be marked Popular — auto-assigned. Save again to confirm.");
        return;
      }

      const tiers = washTemplates.map((t) => {
        const pkg = activeSet.packages.find(
          (p) => String(p.washCatalogId) === String(t.id)
        );
        // UI works in price-per-wash; backend expects the total monthly price per tier.
        const perWashPrices = pkg?.price || {};
        const monthlyPrices = {};
        Object.keys(perWashPrices).forEach((ct) => {
          const perWash = Number(perWashPrices[ct]);
          monthlyPrices[ct] = perWash > 0 && t.washCount > 0 ? perWash * t.washCount : "";
        });
        return {
          templateId: t.id,
          isActive: !!pkg?.on && !pkg?._deleted,
          isFeatured: !!pkg?.on && !pkg?._deleted && !!pkg?.popular,
          prices: monthlyPrices,
        };
      });

      const saveRes = await axios.post(
        `${BASE}/package-sets/seller/save-config`,
        {
          setId: isNewSet ? undefined : (activeSet._apiSetId || undefined),
          setName: activeSet.name || "My Packages",
          serviceNameSnapshot: activeSet.washIncludes || "",
          carTypes: activeSet.vehicleTypes,
          refPrices: activeSet.singleWashPrice,
          tiers,
        },
        { headers: authHeaders() }
      );
      const savedSetId = saveRes.data.data?.setId || activeSet._apiSetId;
      // store the real backend id on the set object itself
      const oldSetId = activeSet.id;
      const reconciledSets = sets.map((s) =>
        s.id === oldSetId ? { ...s, id: savedSetId, _apiSetId: savedSetId } : s
      );
      const reconciledPool = locationPool.map((l) =>
        l.setId === oldSetId ? { ...l, setId: savedSetId } : l
      );

      const prevById = Object.fromEntries(savedPool.map((l) => [l.id, l]));

      for (const loc of reconciledPool) {
        if (!loc._locationId) continue;

        const prev = prevById[loc.id];
        const rawPrev = prev?.setId || null;
        // prevSetId: jo backend pe already attached tha is location ka
        const prevSetId = rawPrev && /^[a-f\d]{24}$/i.test(rawPrev) ? rawPrev : null;
        // currSetId: sirf tab savedSetId hoga jab yeh location is set se attached hai
        // dusre sets ki locations ko bilkul ignore karo
        const isForThisSet = loc.setId === savedSetId;
        const wasForThisSet = prevSetId === savedSetId;
        if (!isForThisSet && !wasForThisSet) continue; // dusre set ki location — skip

        const currSetId = isForThisSet ? savedSetId : null;
        if (prevSetId === currSetId) continue; // koi change nahi

        if (prevSetId === savedSetId && !isForThisSet) {
          // detach: pehle is set mein thi, ab nahi
          await axios.delete(
            `${BASE}/package-sets/seller/${savedSetId}/detach-location/${loc._locationId}`,
            { headers: authHeaders() }
          );
        }
        if (isForThisSet && prevSetId !== savedSetId) {
          // attach: ab is set mein hai, pehle nahi thi
          await axios.post(
            `${BASE}/package-sets/seller/${savedSetId}/attach-location`,
            { locationId: loc._locationId, shopId: loc._shopId, locationDisplayName: loc.name },
            { headers: authHeaders() }
          );
        }
      }

      setSets(reconciledSets);
      setActiveId(savedSetId);
      setLocationPool(reconciledPool);
      setSavedSets(reconciledSets);
      setSavedPool(reconciledPool);
      showToast(isNewSet ? `"${activeSet.name || "Package set"}" created` : `Saved — changes are live for new purchases`);
      setViewMode("list");
    } catch (err) {
      showToast(`Save failed: ${err?.response?.data?.message || err.message}`);
    } finally {
      setSavingSet(false);
    }
  };
  const isNewSet = !!activeSet && String(activeSet.id).startsWith("set-new");
  const hasChanges = useMemo(() => {
    try {
      return (
        JSON.stringify(sets) !== JSON.stringify(savedSets) ||
        JSON.stringify(locationPool) !== JSON.stringify(savedPool)
      );
    } catch (_) {
      return true;
    }
  }, [sets, locationPool, savedSets, savedPool]);

  const saveLabel = isNewSet ? "Create package set" : "Save changes";
  const saveDisabled = isNewSet ? false : !hasChanges;
  const discardDisabled = !hasChanges;
  if (loading) return <MonthlyPackagesSkeleton />;
  if (viewMode === "list" || !activeSet) {
    return (
      <div className="mp-app mp-fade-in">
        <style>{`
          @keyframes mpFadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
          .mp-fade-in{ animation: mpFadeIn .22s ease; }
        `}</style>
        <TopBar />
        <LockNotice />
        <SetsListView
          sets={sets}
          locationPool={locationPool}
          onEdit={handleEditSet}
          onNewSet={handleNewSet}
          onDeleteSet={handleDeleteSet}
        />
        <ConfirmModal
          isOpen={!!confirmDeleteId}
          title="Delete package set?"
          message={`Delete "${sets.find((s) => s.id === confirmDeleteId)?.name || "this set"}"? Locations attached to it will become unassigned.`}
          onConfirm={confirmDeleteSet}
          onCancel={cancelDeleteSet}
        />
        {toast && <div className="mp-toast">{toast}</div>}
      </div>
    );
  }

  // ---- Edit view: full form for the single set the admin clicked "Edit" on ----
  return (
    <div className="mp-app mp-fade-in">
      <style>{`
        @keyframes mpFadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
        .mp-fade-in{ animation: mpFadeIn .22s ease; }
        .mp-back-btn{
          display:inline-flex;align-items:center;gap:6px;padding:8px 14px;border-radius:9px;
          border:1px solid #e7e5f2;background:#fff;color:#4b4b5c;font-weight:600;font-size:12.5px;
          cursor:pointer;transition:background .15s ease, border-color .15s ease;
        }
        .mp-back-btn:hover{background:#f5f4fb;border-color:#d9d4ff;}
      `}</style>
      <TopBar />
      <LockNotice />

      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
        <button className="mp-back-btn" onClick={handleBackToList}>
          ← Back to list
        </button>
        <div style={{ fontWeight: 600, fontSize: 15, color: "#222" }}>
          {isNewSet ? "New package set" : activeSet.name || "Untitled set"}
        </div>
      </div>

      <SetNameAndVehicles set={activeSet} onUpdate={updateActiveSet} />
      <SingleWashPrice set={activeSet} onUpdate={updateActiveSet} />
      <PackagesSection set={activeSet} onUpdateSet={updateActiveSet} washTemplates={washTemplates} />
      <LocationsSection
        set={activeSet}
        locationPool={locationPool}
        onToggleLocation={toggleLocation}
        onCreateLocation={createLocation}
      />

      <FooterBar
        onDiscard={handleDiscard}
        onSave={handleSave}
        saveLabel={saveLabel}
        saveDisabled={saveDisabled}
        discardDisabled={discardDisabled}
        saving={savingSet}
      />
      {toast && <div className="mp-toast">{toast}</div>}
    </div>
  );
}